/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as DashboardImport } from './routes/_dashboard'
import { Route as AuthImport } from './routes/_auth'
import { Route as AuthIndexImport } from './routes/_auth.index'
import { Route as R403IndexImport } from './routes/403.index'
import { Route as DashboardAdminImport } from './routes/_dashboard.admin'
import { Route as AuthResetPasswordImport } from './routes/_auth.reset-password'
import { Route as AuthLoginImport } from './routes/_auth.login'
import { Route as DashboardUsersIndexImport } from './routes/_dashboard/users/index'
import { Route as DashboardTutorialsIndexImport } from './routes/_dashboard/tutorials/index'
import { Route as DashboardMySitesIndexImport } from './routes/_dashboard/my-sites/index'
import { Route as DashboardMyActionsIndexImport } from './routes/_dashboard/my-actions/index'
import { Route as DashboardEnergyUsageIndexImport } from './routes/_dashboard/energy-usage/index'
import { Route as DashboardEnergyMonitoringIndexImport } from './routes/_dashboard/energy-monitoring/index'
import { Route as DashboardAdminIndexImport } from './routes/_dashboard/admin/index'
import { Route as DashboardSiteIdImport } from './routes/_dashboard.site.$id'
import { Route as DashboardUsersCreateIndexImport } from './routes/_dashboard/users/create/index'
import { Route as DashboardEnergyUsageProductionIndexImport } from './routes/_dashboard/energy-usage/production/index'
import { Route as DashboardEnergyUsageMeterAnalysisIndexImport } from './routes/_dashboard/energy-usage/meter-analysis/index'
import { Route as DashboardEnergyUsageLocationAnalysisIndexImport } from './routes/_dashboard/energy-usage/location-analysis/index'
import { Route as DashboardEnergyUsageEvolutionIndexImport } from './routes/_dashboard/energy-usage/evolution/index'
import { Route as DashboardEnergyUsageDashboardIndexImport } from './routes/_dashboard/energy-usage/dashboard/index'
import { Route as DashboardEnergyMonitoringHeatingIndexImport } from './routes/_dashboard/energy-monitoring/heating/index'
import { Route as DashboardEnergyMonitoringAirHandlingUnitIndexImport } from './routes/_dashboard/energy-monitoring/air-handling-unit/index'
import { Route as DashboardCompanySettingsIndexImport } from './routes/_dashboard/company/settings/index'
import { Route as DashboardComfortTemperatureIndexImport } from './routes/_dashboard/comfort/temperature/index'
import { Route as DashboardAirQualitySettingsIndexImport } from './routes/_dashboard/air-quality/settings/index'
import { Route as DashboardAirQualityMapIndexImport } from './routes/_dashboard/air-quality/map/index'
import { Route as DashboardAirQualityHistoryIndexImport } from './routes/_dashboard/air-quality/history/index'
import { Route as DashboardAirQualityConformityIndexImport } from './routes/_dashboard/air-quality/conformity/index'
import { Route as DashboardAdminSynopticsIndexImport } from './routes/_dashboard/admin/synoptics/index'
import { Route as DashboardAdminSidebarSectionsIndexImport } from './routes/_dashboard/admin/sidebar-sections/index'
import { Route as DashboardAdminHeatCurveDefaultIndexImport } from './routes/_dashboard/admin/heat-curve-default/index'
import { Route as DashboardAdminDynamicHeatCurveIndexImport } from './routes/_dashboard/admin/dynamic-heat-curve/index'
import { Route as DashboardUsersEditUserIdIndexImport } from './routes/_dashboard/users/edit/$userId/index'
import { Route as DashboardSiteIdSensorPlanIndexImport } from './routes/_dashboard/site/$id/sensor-plan/index'
import { Route as DashboardSiteIdReportsIndexImport } from './routes/_dashboard/site/$id/reports/index'
import { Route as DashboardSiteIdNonConformityIndexImport } from './routes/_dashboard/site/$id/non-conformity/index'
import { Route as DashboardSiteIdMyActionsIndexImport } from './routes/_dashboard/site/$id/my-actions/index'
import { Route as DashboardSiteIdMonitoringIndexImport } from './routes/_dashboard/site/$id/monitoring/index'
import { Route as DashboardSiteIdMedicalFluidIndexImport } from './routes/_dashboard/site/$id/medical-fluid/index'
import { Route as DashboardSiteIdLogbookIndexImport } from './routes/_dashboard/site/$id/logbook/index'
import { Route as DashboardSiteIdLightingIndexImport } from './routes/_dashboard/site/$id/lighting/index'
import { Route as DashboardSiteIdInformationIndexImport } from './routes/_dashboard/site/$id/information/index'
import { Route as DashboardSiteIdEquipmentIndexImport } from './routes/_dashboard/site/$id/equipment/index'
import { Route as DashboardSiteIdElectricalIndexImport } from './routes/_dashboard/site/$id/electrical/index'
import { Route as DashboardSiteIdDevicesIndexImport } from './routes/_dashboard/site/$id/devices/index'
import { Route as DashboardSiteIdDefaultsIndexImport } from './routes/_dashboard/site/$id/defaults/index'
import { Route as DashboardSiteIdAlertsIndexImport } from './routes/_dashboard/site/$id/alerts/index'
import { Route as DashboardSiteIdAlarmsIndexImport } from './routes/_dashboard/site/$id/alarms/index'
import { Route as DashboardSiteIdActionsDoneIndexImport } from './routes/_dashboard/site/$id/actions-done/index'
import { Route as DashboardSiteIdActionsAssignationIndexImport } from './routes/_dashboard/site/$id/actions-assignation/index'
import { Route as DashboardAirQualityMapFloorIdIndexImport } from './routes/_dashboard/air-quality/map/$floorId/index'
import { Route as DashboardAdminSynopticsCreateIndexImport } from './routes/_dashboard/admin/synoptics/create/index'
import { Route as DashboardAdminSynopticsIdIndexImport } from './routes/_dashboard/admin/synoptics/$id/index'
import { Route as DashboardSiteIdVmcTechnicalIndexImport } from './routes/_dashboard/site/$id/vmc/technical/index'
import { Route as DashboardSiteIdSensorPlanFloorIdIndexImport } from './routes/_dashboard/site/$id/sensor-plan/$floorId/index'
import { Route as DashboardSiteIdOperationSchedulerIndexImport } from './routes/_dashboard/site/$id/operation/scheduler/index'
import { Route as DashboardSiteIdNonConformityActionIdIndexImport } from './routes/_dashboard/site/$id/non-conformity/$actionId/index'
import { Route as DashboardSiteIdMyActionsActionIdIndexImport } from './routes/_dashboard/site/$id/my-actions/$actionId/index'
import { Route as DashboardSiteIdMonitoringDeviceIdIndexImport } from './routes/_dashboard/site/$id/monitoring/$deviceId/index'
import { Route as DashboardSiteIdMedicalFluidFloorIdIndexImport } from './routes/_dashboard/site/$id/medical-fluid/$floorId/index'
import { Route as DashboardSiteIdLogbookAddLogIndexImport } from './routes/_dashboard/site/$id/logbook/add-log/index'
import { Route as DashboardSiteIdLogbookWorkIdIndexImport } from './routes/_dashboard/site/$id/logbook/$workId/index'
import { Route as DashboardSiteIdLightingFloorIdIndexImport } from './routes/_dashboard/site/$id/lighting/$floorId/index'
import { Route as DashboardSiteIdInformationAddWorkIndexImport } from './routes/_dashboard/site/$id/information/add-work/index'
import { Route as DashboardSiteIdHeatPumpTechnicalIndexImport } from './routes/_dashboard/site/$id/heat-pump/technical/index'
import { Route as DashboardSiteIdHeatPumpModeIndexImport } from './routes/_dashboard/site/$id/heat-pump/mode/index'
import { Route as DashboardSiteIdEquipmentEnergyIndexImport } from './routes/_dashboard/site/$id/equipment/energy/index'
import { Route as DashboardSiteIdEquipmentCreateIndexImport } from './routes/_dashboard/site/$id/equipment/create/index'
import { Route as DashboardSiteIdEquipmentChooseSampleIndexImport } from './routes/_dashboard/site/$id/equipment/choose-sample/index'
import { Route as DashboardSiteIdElectricalFloorIdIndexImport } from './routes/_dashboard/site/$id/electrical/$floorId/index'
import { Route as DashboardSiteIdDriftSettingsIndexImport } from './routes/_dashboard/site/$id/drift/settings/index'
import { Route as DashboardSiteIdDriftEquipmentIndexImport } from './routes/_dashboard/site/$id/drift/equipment/index'
import { Route as DashboardSiteIdDefaultsEquipmentIdIndexImport } from './routes/_dashboard/site/$id/defaults/$equipmentId/index'
import { Route as DashboardSiteIdDashboardRecommendationsIndexImport } from './routes/_dashboard/site/$id/dashboard/recommendations/index'
import { Route as DashboardSiteIdDashboardGeneralIndexImport } from './routes/_dashboard/site/$id/dashboard/general/index'
import { Route as DashboardSiteIdComfortMonitoringIndexImport } from './routes/_dashboard/site/$id/comfort/monitoring/index'
import { Route as DashboardSiteIdBoilerRoomTechnicalIndexImport } from './routes/_dashboard/site/$id/boiler-room/technical/index'
import { Route as DashboardSiteIdAlertsCreateIndexImport } from './routes/_dashboard/site/$id/alerts/create/index'
import { Route as DashboardSiteIdAlarmsEquipmentIdIndexImport } from './routes/_dashboard/site/$id/alarms/$equipmentId/index'
import { Route as DashboardSiteIdActionsDoneActionIdIndexImport } from './routes/_dashboard/site/$id/actions-done/$actionId/index'
import { Route as DashboardSiteIdEquipmentEquipmentIdLayoutImport } from './routes/_dashboard/site/$id/equipment/$equipmentId/_layout'
import { Route as DashboardSiteIdVmcTechnicalManageIndexImport } from './routes/_dashboard/site/$id/vmc/technical/manage/index'
import { Route as DashboardSiteIdReportsConfigurationCreateIndexImport } from './routes/_dashboard/site/$id/reports/configuration/create/index'
import { Route as DashboardSiteIdOperationSchedulerCreateIndexImport } from './routes/_dashboard/site/$id/operation/scheduler/create/index'
import { Route as DashboardSiteIdOperationSchedulerScheduleIdIndexImport } from './routes/_dashboard/site/$id/operation/scheduler/$scheduleId/index'
import { Route as DashboardSiteIdInformationWorkWorkIdIndexImport } from './routes/_dashboard/site/$id/information/work/$workId/index'
import { Route as DashboardSiteIdHeatPumpTechnicalManageIndexImport } from './routes/_dashboard/site/$id/heat-pump/technical/manage/index'
import { Route as DashboardSiteIdHeatPumpTechnicalGenerateIndexImport } from './routes/_dashboard/site/$id/heat-pump/technical/generate/index'
import { Route as DashboardSiteIdEquipmentEnergyEquipmentIdIndexImport } from './routes/_dashboard/site/$id/equipment/energy/$equipmentId/index'
import { Route as DashboardSiteIdDevicesEditDeviceIdIndexImport } from './routes/_dashboard/site/$id/devices/edit/$deviceId/index'
import { Route as DashboardSiteIdComfortMonitoringConfigurationIndexImport } from './routes/_dashboard/site/$id/comfort/monitoring/configuration/index'
import { Route as DashboardSiteIdComfortMonitoringFloorIdIndexImport } from './routes/_dashboard/site/$id/comfort/monitoring/$floorId/index'
import { Route as DashboardSiteIdBoilerRoomTechnicalManageIndexImport } from './routes/_dashboard/site/$id/boiler-room/technical/manage/index'
import { Route as DashboardSiteIdBoilerRoomTechnicalGenerateIndexImport } from './routes/_dashboard/site/$id/boiler-room/technical/generate/index'
import { Route as DashboardSiteIdAlertsEditDeviceDisconnectedIndexImport } from './routes/_dashboard/site/$id/alerts/edit/device-disconnected/index'
import { Route as DashboardSiteIdAlertsEditAlertIdIndexImport } from './routes/_dashboard/site/$id/alerts/edit/$alertId/index'
import { Route as DashboardSiteIdEquipmentEquipmentIdLayoutInformationImport } from './routes/_dashboard/site/$id/equipment/$equipmentId/_layout/information'
import { Route as DashboardSiteIdEquipmentEquipmentIdLayoutDevicesImport } from './routes/_dashboard/site/$id/equipment/$equipmentId/_layout/devices'
import { Route as DashboardSiteIdEquipmentEquipmentIdLayoutActionsImport } from './routes/_dashboard/site/$id/equipment/$equipmentId/_layout/actions'
import { Route as DashboardSiteIdReportsConfigurationEditReportIdIndexImport } from './routes/_dashboard/site/$id/reports/configuration/edit/$reportId/index'
import { Route as DashboardSiteIdOperationSchedulerCtaZoneCtaIdIndexImport } from './routes/_dashboard/site/$id/operation/scheduler/cta/$zoneCtaId/index'
import { Route as DashboardSiteIdHeatPumpTechnicalManageSynopticIdIndexImport } from './routes/_dashboard/site/$id/heat-pump/technical/manage/$synopticId/index'
import { Route as DashboardSiteIdBoilerRoomTechnicalManageSynopticIdIndexImport } from './routes/_dashboard/site/$id/boiler-room/technical/manage/$synopticId/index'
import { Route as DashboardSiteIdAlertsEditAlertIdCommentIndexImport } from './routes/_dashboard/site/$id/alerts/edit/$alertId/comment/index'

// Create Virtual Routes

const DashboardMySitesCreateIndexLazyImport = createFileRoute(
  '/_dashboard/my-sites/create/',
)()
const DashboardSiteIdEquipmentEquipmentIdImport = createFileRoute(
  '/_dashboard/site/$id/equipment/$equipmentId',
)()

// Create/Update Routes

const DashboardRoute = DashboardImport.update({
  id: '/_dashboard',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/_dashboard.lazy').then((d) => d.Route))

const AuthRoute = AuthImport.update({
  id: '/_auth',
  getParentRoute: () => rootRoute,
} as any)

const AuthIndexRoute = AuthIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthRoute,
} as any)

const R403IndexRoute = R403IndexImport.update({
  id: '/403/',
  path: '/403/',
  getParentRoute: () => rootRoute,
} as any)

const DashboardAdminRoute = DashboardAdminImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => DashboardRoute,
} as any)

const AuthResetPasswordRoute = AuthResetPasswordImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => AuthRoute,
} as any)

const AuthLoginRoute = AuthLoginImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => AuthRoute,
} as any)

const DashboardUsersIndexRoute = DashboardUsersIndexImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => DashboardRoute,
} as any).lazy(() =>
  import('./routes/_dashboard/users/index.lazy').then((d) => d.Route),
)

const DashboardTutorialsIndexRoute = DashboardTutorialsIndexImport.update({
  id: '/tutorials/',
  path: '/tutorials/',
  getParentRoute: () => DashboardRoute,
} as any).lazy(() =>
  import('./routes/_dashboard/tutorials/index.lazy').then((d) => d.Route),
)

const DashboardMySitesIndexRoute = DashboardMySitesIndexImport.update({
  id: '/my-sites/',
  path: '/my-sites/',
  getParentRoute: () => DashboardRoute,
} as any).lazy(() =>
  import('./routes/_dashboard/my-sites/index.lazy').then((d) => d.Route),
)

const DashboardMyActionsIndexRoute = DashboardMyActionsIndexImport.update({
  id: '/my-actions/',
  path: '/my-actions/',
  getParentRoute: () => DashboardRoute,
} as any).lazy(() =>
  import('./routes/_dashboard/my-actions/index.lazy').then((d) => d.Route),
)

const DashboardEnergyUsageIndexRoute = DashboardEnergyUsageIndexImport.update({
  id: '/energy-usage/',
  path: '/energy-usage/',
  getParentRoute: () => DashboardRoute,
} as any)

const DashboardEnergyMonitoringIndexRoute =
  DashboardEnergyMonitoringIndexImport.update({
    id: '/energy-monitoring/',
    path: '/energy-monitoring/',
    getParentRoute: () => DashboardRoute,
  } as any)

const DashboardAdminIndexRoute = DashboardAdminIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DashboardAdminRoute,
} as any).lazy(() =>
  import('./routes/_dashboard/admin/index.lazy').then((d) => d.Route),
)

const DashboardSiteIdRoute = DashboardSiteIdImport.update({
  id: '/site/$id',
  path: '/site/$id',
  getParentRoute: () => DashboardRoute,
} as any).lazy(() =>
  import('./routes/_dashboard.site.$id.lazy').then((d) => d.Route),
)

const DashboardMySitesCreateIndexLazyRoute =
  DashboardMySitesCreateIndexLazyImport.update({
    id: '/my-sites/create/',
    path: '/my-sites/create/',
    getParentRoute: () => DashboardRoute,
  } as any).lazy(() =>
    import('./routes/_dashboard/my-sites/create/index.lazy').then(
      (d) => d.Route,
    ),
  )

const DashboardUsersCreateIndexRoute = DashboardUsersCreateIndexImport.update({
  id: '/users/create/',
  path: '/users/create/',
  getParentRoute: () => DashboardRoute,
} as any).lazy(() =>
  import('./routes/_dashboard/users/create/index.lazy').then((d) => d.Route),
)

const DashboardEnergyUsageProductionIndexRoute =
  DashboardEnergyUsageProductionIndexImport.update({
    id: '/energy-usage/production/',
    path: '/energy-usage/production/',
    getParentRoute: () => DashboardRoute,
  } as any).lazy(() =>
    import('./routes/_dashboard/energy-usage/production/index.lazy').then(
      (d) => d.Route,
    ),
  )

const DashboardEnergyUsageMeterAnalysisIndexRoute =
  DashboardEnergyUsageMeterAnalysisIndexImport.update({
    id: '/energy-usage/meter-analysis/',
    path: '/energy-usage/meter-analysis/',
    getParentRoute: () => DashboardRoute,
  } as any).lazy(() =>
    import('./routes/_dashboard/energy-usage/meter-analysis/index.lazy').then(
      (d) => d.Route,
    ),
  )

const DashboardEnergyUsageLocationAnalysisIndexRoute =
  DashboardEnergyUsageLocationAnalysisIndexImport.update({
    id: '/energy-usage/location-analysis/',
    path: '/energy-usage/location-analysis/',
    getParentRoute: () => DashboardRoute,
  } as any).lazy(() =>
    import('./routes/_dashboard/energy-usage/location-analysis/index.lazy').then(
      (d) => d.Route,
    ),
  )

const DashboardEnergyUsageEvolutionIndexRoute =
  DashboardEnergyUsageEvolutionIndexImport.update({
    id: '/energy-usage/evolution/',
    path: '/energy-usage/evolution/',
    getParentRoute: () => DashboardRoute,
  } as any).lazy(() =>
    import('./routes/_dashboard/energy-usage/evolution/index.lazy').then(
      (d) => d.Route,
    ),
  )

const DashboardEnergyUsageDashboardIndexRoute =
  DashboardEnergyUsageDashboardIndexImport.update({
    id: '/energy-usage/dashboard/',
    path: '/energy-usage/dashboard/',
    getParentRoute: () => DashboardRoute,
  } as any).lazy(() =>
    import('./routes/_dashboard/energy-usage/dashboard/index.lazy').then(
      (d) => d.Route,
    ),
  )

const DashboardEnergyMonitoringHeatingIndexRoute =
  DashboardEnergyMonitoringHeatingIndexImport.update({
    id: '/energy-monitoring/heating/',
    path: '/energy-monitoring/heating/',
    getParentRoute: () => DashboardRoute,
  } as any).lazy(() =>
    import('./routes/_dashboard/energy-monitoring/heating/index.lazy').then(
      (d) => d.Route,
    ),
  )

const DashboardEnergyMonitoringAirHandlingUnitIndexRoute =
  DashboardEnergyMonitoringAirHandlingUnitIndexImport.update({
    id: '/energy-monitoring/air-handling-unit/',
    path: '/energy-monitoring/air-handling-unit/',
    getParentRoute: () => DashboardRoute,
  } as any).lazy(() =>
    import('./routes/_dashboard/energy-monitoring/air-handling-unit/index.lazy').then(
      (d) => d.Route,
    ),
  )

const DashboardCompanySettingsIndexRoute =
  DashboardCompanySettingsIndexImport.update({
    id: '/company/settings/',
    path: '/company/settings/',
    getParentRoute: () => DashboardRoute,
  } as any).lazy(() =>
    import('./routes/_dashboard/company/settings/index.lazy').then(
      (d) => d.Route,
    ),
  )

const DashboardComfortTemperatureIndexRoute =
  DashboardComfortTemperatureIndexImport.update({
    id: '/comfort/temperature/',
    path: '/comfort/temperature/',
    getParentRoute: () => DashboardRoute,
  } as any).lazy(() =>
    import('./routes/_dashboard/comfort/temperature/index.lazy').then(
      (d) => d.Route,
    ),
  )

const DashboardAirQualitySettingsIndexRoute =
  DashboardAirQualitySettingsIndexImport.update({
    id: '/air-quality/settings/',
    path: '/air-quality/settings/',
    getParentRoute: () => DashboardRoute,
  } as any).lazy(() =>
    import('./routes/_dashboard/air-quality/settings/index.lazy').then(
      (d) => d.Route,
    ),
  )

const DashboardAirQualityMapIndexRoute =
  DashboardAirQualityMapIndexImport.update({
    id: '/air-quality/map/',
    path: '/air-quality/map/',
    getParentRoute: () => DashboardRoute,
  } as any).lazy(() =>
    import('./routes/_dashboard/air-quality/map/index.lazy').then(
      (d) => d.Route,
    ),
  )

const DashboardAirQualityHistoryIndexRoute =
  DashboardAirQualityHistoryIndexImport.update({
    id: '/air-quality/history/',
    path: '/air-quality/history/',
    getParentRoute: () => DashboardRoute,
  } as any).lazy(() =>
    import('./routes/_dashboard/air-quality/history/index.lazy').then(
      (d) => d.Route,
    ),
  )

const DashboardAirQualityConformityIndexRoute =
  DashboardAirQualityConformityIndexImport.update({
    id: '/air-quality/conformity/',
    path: '/air-quality/conformity/',
    getParentRoute: () => DashboardRoute,
  } as any).lazy(() =>
    import('./routes/_dashboard/air-quality/conformity/index.lazy').then(
      (d) => d.Route,
    ),
  )

const DashboardAdminSynopticsIndexRoute =
  DashboardAdminSynopticsIndexImport.update({
    id: '/synoptics/',
    path: '/synoptics/',
    getParentRoute: () => DashboardAdminRoute,
  } as any).lazy(() =>
    import('./routes/_dashboard/admin/synoptics/index.lazy').then(
      (d) => d.Route,
    ),
  )

const DashboardAdminSidebarSectionsIndexRoute =
  DashboardAdminSidebarSectionsIndexImport.update({
    id: '/sidebar-sections/',
    path: '/sidebar-sections/',
    getParentRoute: () => DashboardAdminRoute,
  } as any).lazy(() =>
    import('./routes/_dashboard/admin/sidebar-sections/index.lazy').then(
      (d) => d.Route,
    ),
  )

const DashboardAdminHeatCurveDefaultIndexRoute =
  DashboardAdminHeatCurveDefaultIndexImport.update({
    id: '/heat-curve-default/',
    path: '/heat-curve-default/',
    getParentRoute: () => DashboardAdminRoute,
  } as any).lazy(() =>
    import('./routes/_dashboard/admin/heat-curve-default/index.lazy').then(
      (d) => d.Route,
    ),
  )

const DashboardAdminDynamicHeatCurveIndexRoute =
  DashboardAdminDynamicHeatCurveIndexImport.update({
    id: '/dynamic-heat-curve/',
    path: '/dynamic-heat-curve/',
    getParentRoute: () => DashboardAdminRoute,
  } as any).lazy(() =>
    import('./routes/_dashboard/admin/dynamic-heat-curve/index.lazy').then(
      (d) => d.Route,
    ),
  )

const DashboardSiteIdEquipmentEquipmentIdRoute =
  DashboardSiteIdEquipmentEquipmentIdImport.update({
    id: '/equipment/$equipmentId',
    path: '/equipment/$equipmentId',
    getParentRoute: () => DashboardSiteIdRoute,
  } as any)

const DashboardUsersEditUserIdIndexRoute =
  DashboardUsersEditUserIdIndexImport.update({
    id: '/users/edit/$userId/',
    path: '/users/edit/$userId/',
    getParentRoute: () => DashboardRoute,
  } as any).lazy(() =>
    import('./routes/_dashboard/users/edit/$userId/index.lazy').then(
      (d) => d.Route,
    ),
  )

const DashboardSiteIdSensorPlanIndexRoute =
  DashboardSiteIdSensorPlanIndexImport.update({
    id: '/sensor-plan/',
    path: '/sensor-plan/',
    getParentRoute: () => DashboardSiteIdRoute,
  } as any).lazy(() =>
    import('./routes/_dashboard/site/$id/sensor-plan/index.lazy').then(
      (d) => d.Route,
    ),
  )

const DashboardSiteIdReportsIndexRoute =
  DashboardSiteIdReportsIndexImport.update({
    id: '/reports/',
    path: '/reports/',
    getParentRoute: () => DashboardSiteIdRoute,
  } as any).lazy(() =>
    import('./routes/_dashboard/site/$id/reports/index.lazy').then(
      (d) => d.Route,
    ),
  )

const DashboardSiteIdNonConformityIndexRoute =
  DashboardSiteIdNonConformityIndexImport.update({
    id: '/non-conformity/',
    path: '/non-conformity/',
    getParentRoute: () => DashboardSiteIdRoute,
  } as any).lazy(() =>
    import('./routes/_dashboard/site/$id/non-conformity/index.lazy').then(
      (d) => d.Route,
    ),
  )

const DashboardSiteIdMyActionsIndexRoute =
  DashboardSiteIdMyActionsIndexImport.update({
    id: '/my-actions/',
    path: '/my-actions/',
    getParentRoute: () => DashboardSiteIdRoute,
  } as any).lazy(() =>
    import('./routes/_dashboard/site/$id/my-actions/index.lazy').then(
      (d) => d.Route,
    ),
  )

const DashboardSiteIdMonitoringIndexRoute =
  DashboardSiteIdMonitoringIndexImport.update({
    id: '/monitoring/',
    path: '/monitoring/',
    getParentRoute: () => DashboardSiteIdRoute,
  } as any).lazy(() =>
    import('./routes/_dashboard/site/$id/monitoring/index.lazy').then(
      (d) => d.Route,
    ),
  )

const DashboardSiteIdMedicalFluidIndexRoute =
  DashboardSiteIdMedicalFluidIndexImport.update({
    id: '/medical-fluid/',
    path: '/medical-fluid/',
    getParentRoute: () => DashboardSiteIdRoute,
  } as any).lazy(() =>
    import('./routes/_dashboard/site/$id/medical-fluid/index.lazy').then(
      (d) => d.Route,
    ),
  )

const DashboardSiteIdLogbookIndexRoute =
  DashboardSiteIdLogbookIndexImport.update({
    id: '/logbook/',
    path: '/logbook/',
    getParentRoute: () => DashboardSiteIdRoute,
  } as any).lazy(() =>
    import('./routes/_dashboard/site/$id/logbook/index.lazy').then(
      (d) => d.Route,
    ),
  )

const DashboardSiteIdLightingIndexRoute =
  DashboardSiteIdLightingIndexImport.update({
    id: '/lighting/',
    path: '/lighting/',
    getParentRoute: () => DashboardSiteIdRoute,
  } as any).lazy(() =>
    import('./routes/_dashboard/site/$id/lighting/index.lazy').then(
      (d) => d.Route,
    ),
  )

const DashboardSiteIdInformationIndexRoute =
  DashboardSiteIdInformationIndexImport.update({
    id: '/information/',
    path: '/information/',
    getParentRoute: () => DashboardSiteIdRoute,
  } as any).lazy(() =>
    import('./routes/_dashboard/site/$id/information/index.lazy').then(
      (d) => d.Route,
    ),
  )

const DashboardSiteIdEquipmentIndexRoute =
  DashboardSiteIdEquipmentIndexImport.update({
    id: '/equipment/',
    path: '/equipment/',
    getParentRoute: () => DashboardSiteIdRoute,
  } as any).lazy(() =>
    import('./routes/_dashboard/site/$id/equipment/index.lazy').then(
      (d) => d.Route,
    ),
  )

const DashboardSiteIdElectricalIndexRoute =
  DashboardSiteIdElectricalIndexImport.update({
    id: '/electrical/',
    path: '/electrical/',
    getParentRoute: () => DashboardSiteIdRoute,
  } as any).lazy(() =>
    import('./routes/_dashboard/site/$id/electrical/index.lazy').then(
      (d) => d.Route,
    ),
  )

const DashboardSiteIdDevicesIndexRoute =
  DashboardSiteIdDevicesIndexImport.update({
    id: '/devices/',
    path: '/devices/',
    getParentRoute: () => DashboardSiteIdRoute,
  } as any).lazy(() =>
    import('./routes/_dashboard/site/$id/devices/index.lazy').then(
      (d) => d.Route,
    ),
  )

const DashboardSiteIdDefaultsIndexRoute =
  DashboardSiteIdDefaultsIndexImport.update({
    id: '/defaults/',
    path: '/defaults/',
    getParentRoute: () => DashboardSiteIdRoute,
  } as any).lazy(() =>
    import('./routes/_dashboard/site/$id/defaults/index.lazy').then(
      (d) => d.Route,
    ),
  )

const DashboardSiteIdAlertsIndexRoute = DashboardSiteIdAlertsIndexImport.update(
  {
    id: '/alerts/',
    path: '/alerts/',
    getParentRoute: () => DashboardSiteIdRoute,
  } as any,
).lazy(() =>
  import('./routes/_dashboard/site/$id/alerts/index.lazy').then((d) => d.Route),
)

const DashboardSiteIdAlarmsIndexRoute = DashboardSiteIdAlarmsIndexImport.update(
  {
    id: '/alarms/',
    path: '/alarms/',
    getParentRoute: () => DashboardSiteIdRoute,
  } as any,
).lazy(() =>
  import('./routes/_dashboard/site/$id/alarms/index.lazy').then((d) => d.Route),
)

const DashboardSiteIdActionsDoneIndexRoute =
  DashboardSiteIdActionsDoneIndexImport.update({
    id: '/actions-done/',
    path: '/actions-done/',
    getParentRoute: () => DashboardSiteIdRoute,
  } as any).lazy(() =>
    import('./routes/_dashboard/site/$id/actions-done/index.lazy').then(
      (d) => d.Route,
    ),
  )

const DashboardSiteIdActionsAssignationIndexRoute =
  DashboardSiteIdActionsAssignationIndexImport.update({
    id: '/actions-assignation/',
    path: '/actions-assignation/',
    getParentRoute: () => DashboardSiteIdRoute,
  } as any).lazy(() =>
    import('./routes/_dashboard/site/$id/actions-assignation/index.lazy').then(
      (d) => d.Route,
    ),
  )

const DashboardAirQualityMapFloorIdIndexRoute =
  DashboardAirQualityMapFloorIdIndexImport.update({
    id: '/air-quality/map/$floorId/',
    path: '/air-quality/map/$floorId/',
    getParentRoute: () => DashboardRoute,
  } as any).lazy(() =>
    import('./routes/_dashboard/air-quality/map/$floorId/index.lazy').then(
      (d) => d.Route,
    ),
  )

const DashboardAdminSynopticsCreateIndexRoute =
  DashboardAdminSynopticsCreateIndexImport.update({
    id: '/synoptics/create/',
    path: '/synoptics/create/',
    getParentRoute: () => DashboardAdminRoute,
  } as any).lazy(() =>
    import('./routes/_dashboard/admin/synoptics/create/index.lazy').then(
      (d) => d.Route,
    ),
  )

const DashboardAdminSynopticsIdIndexRoute =
  DashboardAdminSynopticsIdIndexImport.update({
    id: '/synoptics/$id/',
    path: '/synoptics/$id/',
    getParentRoute: () => DashboardAdminRoute,
  } as any).lazy(() =>
    import('./routes/_dashboard/admin/synoptics/$id/index.lazy').then(
      (d) => d.Route,
    ),
  )

const DashboardSiteIdVmcTechnicalIndexRoute =
  DashboardSiteIdVmcTechnicalIndexImport.update({
    id: '/vmc/technical/',
    path: '/vmc/technical/',
    getParentRoute: () => DashboardSiteIdRoute,
  } as any).lazy(() =>
    import('./routes/_dashboard/site/$id/vmc/technical/index.lazy').then(
      (d) => d.Route,
    ),
  )

const DashboardSiteIdSensorPlanFloorIdIndexRoute =
  DashboardSiteIdSensorPlanFloorIdIndexImport.update({
    id: '/sensor-plan/$floorId/',
    path: '/sensor-plan/$floorId/',
    getParentRoute: () => DashboardSiteIdRoute,
  } as any).lazy(() =>
    import('./routes/_dashboard/site/$id/sensor-plan/$floorId/index.lazy').then(
      (d) => d.Route,
    ),
  )

const DashboardSiteIdOperationSchedulerIndexRoute =
  DashboardSiteIdOperationSchedulerIndexImport.update({
    id: '/operation/scheduler/',
    path: '/operation/scheduler/',
    getParentRoute: () => DashboardSiteIdRoute,
  } as any).lazy(() =>
    import('./routes/_dashboard/site/$id/operation/scheduler/index.lazy').then(
      (d) => d.Route,
    ),
  )

const DashboardSiteIdNonConformityActionIdIndexRoute =
  DashboardSiteIdNonConformityActionIdIndexImport.update({
    id: '/non-conformity/$actionId/',
    path: '/non-conformity/$actionId/',
    getParentRoute: () => DashboardSiteIdRoute,
  } as any).lazy(() =>
    import('./routes/_dashboard/site/$id/non-conformity/$actionId/index.lazy').then(
      (d) => d.Route,
    ),
  )

const DashboardSiteIdMyActionsActionIdIndexRoute =
  DashboardSiteIdMyActionsActionIdIndexImport.update({
    id: '/my-actions/$actionId/',
    path: '/my-actions/$actionId/',
    getParentRoute: () => DashboardSiteIdRoute,
  } as any).lazy(() =>
    import('./routes/_dashboard/site/$id/my-actions/$actionId/index.lazy').then(
      (d) => d.Route,
    ),
  )

const DashboardSiteIdMonitoringDeviceIdIndexRoute =
  DashboardSiteIdMonitoringDeviceIdIndexImport.update({
    id: '/monitoring/$deviceId/',
    path: '/monitoring/$deviceId/',
    getParentRoute: () => DashboardSiteIdRoute,
  } as any).lazy(() =>
    import('./routes/_dashboard/site/$id/monitoring/$deviceId/index.lazy').then(
      (d) => d.Route,
    ),
  )

const DashboardSiteIdMedicalFluidFloorIdIndexRoute =
  DashboardSiteIdMedicalFluidFloorIdIndexImport.update({
    id: '/medical-fluid/$floorId/',
    path: '/medical-fluid/$floorId/',
    getParentRoute: () => DashboardSiteIdRoute,
  } as any).lazy(() =>
    import('./routes/_dashboard/site/$id/medical-fluid/$floorId/index.lazy').then(
      (d) => d.Route,
    ),
  )

const DashboardSiteIdLogbookAddLogIndexRoute =
  DashboardSiteIdLogbookAddLogIndexImport.update({
    id: '/logbook/add-log/',
    path: '/logbook/add-log/',
    getParentRoute: () => DashboardSiteIdRoute,
  } as any).lazy(() =>
    import('./routes/_dashboard/site/$id/logbook/add-log/index.lazy').then(
      (d) => d.Route,
    ),
  )

const DashboardSiteIdLogbookWorkIdIndexRoute =
  DashboardSiteIdLogbookWorkIdIndexImport.update({
    id: '/logbook/$workId/',
    path: '/logbook/$workId/',
    getParentRoute: () => DashboardSiteIdRoute,
  } as any).lazy(() =>
    import('./routes/_dashboard/site/$id/logbook/$workId/index.lazy').then(
      (d) => d.Route,
    ),
  )

const DashboardSiteIdLightingFloorIdIndexRoute =
  DashboardSiteIdLightingFloorIdIndexImport.update({
    id: '/lighting/$floorId/',
    path: '/lighting/$floorId/',
    getParentRoute: () => DashboardSiteIdRoute,
  } as any).lazy(() =>
    import('./routes/_dashboard/site/$id/lighting/$floorId/index.lazy').then(
      (d) => d.Route,
    ),
  )

const DashboardSiteIdInformationAddWorkIndexRoute =
  DashboardSiteIdInformationAddWorkIndexImport.update({
    id: '/information/add-work/',
    path: '/information/add-work/',
    getParentRoute: () => DashboardSiteIdRoute,
  } as any).lazy(() =>
    import('./routes/_dashboard/site/$id/information/add-work/index.lazy').then(
      (d) => d.Route,
    ),
  )

const DashboardSiteIdHeatPumpTechnicalIndexRoute =
  DashboardSiteIdHeatPumpTechnicalIndexImport.update({
    id: '/heat-pump/technical/',
    path: '/heat-pump/technical/',
    getParentRoute: () => DashboardSiteIdRoute,
  } as any).lazy(() =>
    import('./routes/_dashboard/site/$id/heat-pump/technical/index.lazy').then(
      (d) => d.Route,
    ),
  )

const DashboardSiteIdHeatPumpModeIndexRoute =
  DashboardSiteIdHeatPumpModeIndexImport.update({
    id: '/heat-pump/mode/',
    path: '/heat-pump/mode/',
    getParentRoute: () => DashboardSiteIdRoute,
  } as any)

const DashboardSiteIdEquipmentEnergyIndexRoute =
  DashboardSiteIdEquipmentEnergyIndexImport.update({
    id: '/equipment/energy/',
    path: '/equipment/energy/',
    getParentRoute: () => DashboardSiteIdRoute,
  } as any).lazy(() =>
    import('./routes/_dashboard/site/$id/equipment/energy/index.lazy').then(
      (d) => d.Route,
    ),
  )

const DashboardSiteIdEquipmentCreateIndexRoute =
  DashboardSiteIdEquipmentCreateIndexImport.update({
    id: '/equipment/create/',
    path: '/equipment/create/',
    getParentRoute: () => DashboardSiteIdRoute,
  } as any).lazy(() =>
    import('./routes/_dashboard/site/$id/equipment/create/index.lazy').then(
      (d) => d.Route,
    ),
  )

const DashboardSiteIdEquipmentChooseSampleIndexRoute =
  DashboardSiteIdEquipmentChooseSampleIndexImport.update({
    id: '/equipment/choose-sample/',
    path: '/equipment/choose-sample/',
    getParentRoute: () => DashboardSiteIdRoute,
  } as any).lazy(() =>
    import('./routes/_dashboard/site/$id/equipment/choose-sample/index.lazy').then(
      (d) => d.Route,
    ),
  )

const DashboardSiteIdElectricalFloorIdIndexRoute =
  DashboardSiteIdElectricalFloorIdIndexImport.update({
    id: '/electrical/$floorId/',
    path: '/electrical/$floorId/',
    getParentRoute: () => DashboardSiteIdRoute,
  } as any).lazy(() =>
    import('./routes/_dashboard/site/$id/electrical/$floorId/index.lazy').then(
      (d) => d.Route,
    ),
  )

const DashboardSiteIdDriftSettingsIndexRoute =
  DashboardSiteIdDriftSettingsIndexImport.update({
    id: '/drift/settings/',
    path: '/drift/settings/',
    getParentRoute: () => DashboardSiteIdRoute,
  } as any)

const DashboardSiteIdDriftEquipmentIndexRoute =
  DashboardSiteIdDriftEquipmentIndexImport.update({
    id: '/drift/equipment/',
    path: '/drift/equipment/',
    getParentRoute: () => DashboardSiteIdRoute,
  } as any)

const DashboardSiteIdDefaultsEquipmentIdIndexRoute =
  DashboardSiteIdDefaultsEquipmentIdIndexImport.update({
    id: '/defaults/$equipmentId/',
    path: '/defaults/$equipmentId/',
    getParentRoute: () => DashboardSiteIdRoute,
  } as any).lazy(() =>
    import('./routes/_dashboard/site/$id/defaults/$equipmentId/index.lazy').then(
      (d) => d.Route,
    ),
  )

const DashboardSiteIdDashboardRecommendationsIndexRoute =
  DashboardSiteIdDashboardRecommendationsIndexImport.update({
    id: '/dashboard/recommendations/',
    path: '/dashboard/recommendations/',
    getParentRoute: () => DashboardSiteIdRoute,
  } as any).lazy(() =>
    import('./routes/_dashboard/site/$id/dashboard/recommendations/index.lazy').then(
      (d) => d.Route,
    ),
  )

const DashboardSiteIdDashboardGeneralIndexRoute =
  DashboardSiteIdDashboardGeneralIndexImport.update({
    id: '/dashboard/general/',
    path: '/dashboard/general/',
    getParentRoute: () => DashboardSiteIdRoute,
  } as any).lazy(() =>
    import('./routes/_dashboard/site/$id/dashboard/general/index.lazy').then(
      (d) => d.Route,
    ),
  )

const DashboardSiteIdComfortMonitoringIndexRoute =
  DashboardSiteIdComfortMonitoringIndexImport.update({
    id: '/comfort/monitoring/',
    path: '/comfort/monitoring/',
    getParentRoute: () => DashboardSiteIdRoute,
  } as any).lazy(() =>
    import('./routes/_dashboard/site/$id/comfort/monitoring/index.lazy').then(
      (d) => d.Route,
    ),
  )

const DashboardSiteIdBoilerRoomTechnicalIndexRoute =
  DashboardSiteIdBoilerRoomTechnicalIndexImport.update({
    id: '/boiler-room/technical/',
    path: '/boiler-room/technical/',
    getParentRoute: () => DashboardSiteIdRoute,
  } as any).lazy(() =>
    import('./routes/_dashboard/site/$id/boiler-room/technical/index.lazy').then(
      (d) => d.Route,
    ),
  )

const DashboardSiteIdAlertsCreateIndexRoute =
  DashboardSiteIdAlertsCreateIndexImport.update({
    id: '/alerts/create/',
    path: '/alerts/create/',
    getParentRoute: () => DashboardSiteIdRoute,
  } as any).lazy(() =>
    import('./routes/_dashboard/site/$id/alerts/create/index.lazy').then(
      (d) => d.Route,
    ),
  )

const DashboardSiteIdAlarmsEquipmentIdIndexRoute =
  DashboardSiteIdAlarmsEquipmentIdIndexImport.update({
    id: '/alarms/$equipmentId/',
    path: '/alarms/$equipmentId/',
    getParentRoute: () => DashboardSiteIdRoute,
  } as any).lazy(() =>
    import('./routes/_dashboard/site/$id/alarms/$equipmentId/index.lazy').then(
      (d) => d.Route,
    ),
  )

const DashboardSiteIdActionsDoneActionIdIndexRoute =
  DashboardSiteIdActionsDoneActionIdIndexImport.update({
    id: '/actions-done/$actionId/',
    path: '/actions-done/$actionId/',
    getParentRoute: () => DashboardSiteIdRoute,
  } as any).lazy(() =>
    import('./routes/_dashboard/site/$id/actions-done/$actionId/index.lazy').then(
      (d) => d.Route,
    ),
  )

const DashboardSiteIdEquipmentEquipmentIdLayoutRoute =
  DashboardSiteIdEquipmentEquipmentIdLayoutImport.update({
    id: '/_layout',
    getParentRoute: () => DashboardSiteIdEquipmentEquipmentIdRoute,
  } as any)

const DashboardSiteIdVmcTechnicalManageIndexRoute =
  DashboardSiteIdVmcTechnicalManageIndexImport.update({
    id: '/vmc/technical/manage/',
    path: '/vmc/technical/manage/',
    getParentRoute: () => DashboardSiteIdRoute,
  } as any).lazy(() =>
    import('./routes/_dashboard/site/$id/vmc/technical/manage/index.lazy').then(
      (d) => d.Route,
    ),
  )

const DashboardSiteIdReportsConfigurationCreateIndexRoute =
  DashboardSiteIdReportsConfigurationCreateIndexImport.update({
    id: '/reports/configuration/create/',
    path: '/reports/configuration/create/',
    getParentRoute: () => DashboardSiteIdRoute,
  } as any).lazy(() =>
    import('./routes/_dashboard/site/$id/reports/configuration/create/index.lazy').then(
      (d) => d.Route,
    ),
  )

const DashboardSiteIdOperationSchedulerCreateIndexRoute =
  DashboardSiteIdOperationSchedulerCreateIndexImport.update({
    id: '/operation/scheduler/create/',
    path: '/operation/scheduler/create/',
    getParentRoute: () => DashboardSiteIdRoute,
  } as any).lazy(() =>
    import('./routes/_dashboard/site/$id/operation/scheduler/create/index.lazy').then(
      (d) => d.Route,
    ),
  )

const DashboardSiteIdOperationSchedulerScheduleIdIndexRoute =
  DashboardSiteIdOperationSchedulerScheduleIdIndexImport.update({
    id: '/operation/scheduler/$scheduleId/',
    path: '/operation/scheduler/$scheduleId/',
    getParentRoute: () => DashboardSiteIdRoute,
  } as any).lazy(() =>
    import('./routes/_dashboard/site/$id/operation/scheduler/$scheduleId/index.lazy').then(
      (d) => d.Route,
    ),
  )

const DashboardSiteIdInformationWorkWorkIdIndexRoute =
  DashboardSiteIdInformationWorkWorkIdIndexImport.update({
    id: '/information/work/$workId/',
    path: '/information/work/$workId/',
    getParentRoute: () => DashboardSiteIdRoute,
  } as any).lazy(() =>
    import('./routes/_dashboard/site/$id/information/work/$workId/index.lazy').then(
      (d) => d.Route,
    ),
  )

const DashboardSiteIdHeatPumpTechnicalManageIndexRoute =
  DashboardSiteIdHeatPumpTechnicalManageIndexImport.update({
    id: '/heat-pump/technical/manage/',
    path: '/heat-pump/technical/manage/',
    getParentRoute: () => DashboardSiteIdRoute,
  } as any).lazy(() =>
    import('./routes/_dashboard/site/$id/heat-pump/technical/manage/index.lazy').then(
      (d) => d.Route,
    ),
  )

const DashboardSiteIdHeatPumpTechnicalGenerateIndexRoute =
  DashboardSiteIdHeatPumpTechnicalGenerateIndexImport.update({
    id: '/heat-pump/technical/generate/',
    path: '/heat-pump/technical/generate/',
    getParentRoute: () => DashboardSiteIdRoute,
  } as any).lazy(() =>
    import('./routes/_dashboard/site/$id/heat-pump/technical/generate/index.lazy').then(
      (d) => d.Route,
    ),
  )

const DashboardSiteIdEquipmentEnergyEquipmentIdIndexRoute =
  DashboardSiteIdEquipmentEnergyEquipmentIdIndexImport.update({
    id: '/equipment/energy/$equipmentId/',
    path: '/equipment/energy/$equipmentId/',
    getParentRoute: () => DashboardSiteIdRoute,
  } as any).lazy(() =>
    import('./routes/_dashboard/site/$id/equipment/energy/$equipmentId/index.lazy').then(
      (d) => d.Route,
    ),
  )

const DashboardSiteIdDevicesEditDeviceIdIndexRoute =
  DashboardSiteIdDevicesEditDeviceIdIndexImport.update({
    id: '/devices/edit/$deviceId/',
    path: '/devices/edit/$deviceId/',
    getParentRoute: () => DashboardSiteIdRoute,
  } as any).lazy(() =>
    import('./routes/_dashboard/site/$id/devices/edit/$deviceId/index.lazy').then(
      (d) => d.Route,
    ),
  )

const DashboardSiteIdComfortMonitoringConfigurationIndexRoute =
  DashboardSiteIdComfortMonitoringConfigurationIndexImport.update({
    id: '/comfort/monitoring/configuration/',
    path: '/comfort/monitoring/configuration/',
    getParentRoute: () => DashboardSiteIdRoute,
  } as any).lazy(() =>
    import('./routes/_dashboard/site/$id/comfort/monitoring/configuration/index.lazy').then(
      (d) => d.Route,
    ),
  )

const DashboardSiteIdComfortMonitoringFloorIdIndexRoute =
  DashboardSiteIdComfortMonitoringFloorIdIndexImport.update({
    id: '/comfort/monitoring/$floorId/',
    path: '/comfort/monitoring/$floorId/',
    getParentRoute: () => DashboardSiteIdRoute,
  } as any).lazy(() =>
    import('./routes/_dashboard/site/$id/comfort/monitoring/$floorId/index.lazy').then(
      (d) => d.Route,
    ),
  )

const DashboardSiteIdBoilerRoomTechnicalManageIndexRoute =
  DashboardSiteIdBoilerRoomTechnicalManageIndexImport.update({
    id: '/boiler-room/technical/manage/',
    path: '/boiler-room/technical/manage/',
    getParentRoute: () => DashboardSiteIdRoute,
  } as any).lazy(() =>
    import('./routes/_dashboard/site/$id/boiler-room/technical/manage/index.lazy').then(
      (d) => d.Route,
    ),
  )

const DashboardSiteIdBoilerRoomTechnicalGenerateIndexRoute =
  DashboardSiteIdBoilerRoomTechnicalGenerateIndexImport.update({
    id: '/boiler-room/technical/generate/',
    path: '/boiler-room/technical/generate/',
    getParentRoute: () => DashboardSiteIdRoute,
  } as any).lazy(() =>
    import('./routes/_dashboard/site/$id/boiler-room/technical/generate/index.lazy').then(
      (d) => d.Route,
    ),
  )

const DashboardSiteIdAlertsEditDeviceDisconnectedIndexRoute =
  DashboardSiteIdAlertsEditDeviceDisconnectedIndexImport.update({
    id: '/alerts/edit/device-disconnected/',
    path: '/alerts/edit/device-disconnected/',
    getParentRoute: () => DashboardSiteIdRoute,
  } as any).lazy(() =>
    import('./routes/_dashboard/site/$id/alerts/edit/device-disconnected/index.lazy').then(
      (d) => d.Route,
    ),
  )

const DashboardSiteIdAlertsEditAlertIdIndexRoute =
  DashboardSiteIdAlertsEditAlertIdIndexImport.update({
    id: '/alerts/edit/$alertId/',
    path: '/alerts/edit/$alertId/',
    getParentRoute: () => DashboardSiteIdRoute,
  } as any).lazy(() =>
    import('./routes/_dashboard/site/$id/alerts/edit/$alertId/index.lazy').then(
      (d) => d.Route,
    ),
  )

const DashboardSiteIdEquipmentEquipmentIdLayoutInformationRoute =
  DashboardSiteIdEquipmentEquipmentIdLayoutInformationImport.update({
    id: '/information',
    path: '/information',
    getParentRoute: () => DashboardSiteIdEquipmentEquipmentIdLayoutRoute,
  } as any).lazy(() =>
    import('./routes/_dashboard/site/$id/equipment/$equipmentId/_layout/information.lazy').then(
      (d) => d.Route,
    ),
  )

const DashboardSiteIdEquipmentEquipmentIdLayoutDevicesRoute =
  DashboardSiteIdEquipmentEquipmentIdLayoutDevicesImport.update({
    id: '/devices',
    path: '/devices',
    getParentRoute: () => DashboardSiteIdEquipmentEquipmentIdLayoutRoute,
  } as any).lazy(() =>
    import('./routes/_dashboard/site/$id/equipment/$equipmentId/_layout/devices.lazy').then(
      (d) => d.Route,
    ),
  )

const DashboardSiteIdEquipmentEquipmentIdLayoutActionsRoute =
  DashboardSiteIdEquipmentEquipmentIdLayoutActionsImport.update({
    id: '/actions',
    path: '/actions',
    getParentRoute: () => DashboardSiteIdEquipmentEquipmentIdLayoutRoute,
  } as any).lazy(() =>
    import('./routes/_dashboard/site/$id/equipment/$equipmentId/_layout/actions.lazy').then(
      (d) => d.Route,
    ),
  )

const DashboardSiteIdReportsConfigurationEditReportIdIndexRoute =
  DashboardSiteIdReportsConfigurationEditReportIdIndexImport.update({
    id: '/reports/configuration/edit/$reportId/',
    path: '/reports/configuration/edit/$reportId/',
    getParentRoute: () => DashboardSiteIdRoute,
  } as any).lazy(() =>
    import('./routes/_dashboard/site/$id/reports/configuration/edit/$reportId/index.lazy').then(
      (d) => d.Route,
    ),
  )

const DashboardSiteIdOperationSchedulerCtaZoneCtaIdIndexRoute =
  DashboardSiteIdOperationSchedulerCtaZoneCtaIdIndexImport.update({
    id: '/operation/scheduler/cta/$zoneCtaId/',
    path: '/operation/scheduler/cta/$zoneCtaId/',
    getParentRoute: () => DashboardSiteIdRoute,
  } as any).lazy(() =>
    import('./routes/_dashboard/site/$id/operation/scheduler/cta/$zoneCtaId/index.lazy').then(
      (d) => d.Route,
    ),
  )

const DashboardSiteIdHeatPumpTechnicalManageSynopticIdIndexRoute =
  DashboardSiteIdHeatPumpTechnicalManageSynopticIdIndexImport.update({
    id: '/heat-pump/technical/manage/$synopticId/',
    path: '/heat-pump/technical/manage/$synopticId/',
    getParentRoute: () => DashboardSiteIdRoute,
  } as any).lazy(() =>
    import('./routes/_dashboard/site/$id/heat-pump/technical/manage/$synopticId/index.lazy').then(
      (d) => d.Route,
    ),
  )

const DashboardSiteIdBoilerRoomTechnicalManageSynopticIdIndexRoute =
  DashboardSiteIdBoilerRoomTechnicalManageSynopticIdIndexImport.update({
    id: '/boiler-room/technical/manage/$synopticId/',
    path: '/boiler-room/technical/manage/$synopticId/',
    getParentRoute: () => DashboardSiteIdRoute,
  } as any).lazy(() =>
    import('./routes/_dashboard/site/$id/boiler-room/technical/manage/$synopticId/index.lazy').then(
      (d) => d.Route,
    ),
  )

const DashboardSiteIdAlertsEditAlertIdCommentIndexRoute =
  DashboardSiteIdAlertsEditAlertIdCommentIndexImport.update({
    id: '/alerts/edit/$alertId/comment/',
    path: '/alerts/edit/$alertId/comment/',
    getParentRoute: () => DashboardSiteIdRoute,
  } as any).lazy(() =>
    import('./routes/_dashboard/site/$id/alerts/edit/$alertId/comment/index.lazy').then(
      (d) => d.Route,
    ),
  )

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthImport
      parentRoute: typeof rootRoute
    }
    '/_dashboard': {
      id: '/_dashboard'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof DashboardImport
      parentRoute: typeof rootRoute
    }
    '/_auth/login': {
      id: '/_auth/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof AuthLoginImport
      parentRoute: typeof AuthImport
    }
    '/_auth/reset-password': {
      id: '/_auth/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof AuthResetPasswordImport
      parentRoute: typeof AuthImport
    }
    '/_dashboard/admin': {
      id: '/_dashboard/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof DashboardAdminImport
      parentRoute: typeof DashboardImport
    }
    '/403/': {
      id: '/403/'
      path: '/403'
      fullPath: '/403'
      preLoaderRoute: typeof R403IndexImport
      parentRoute: typeof rootRoute
    }
    '/_auth/': {
      id: '/_auth/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthIndexImport
      parentRoute: typeof AuthImport
    }
    '/_dashboard/site/$id': {
      id: '/_dashboard/site/$id'
      path: '/site/$id'
      fullPath: '/site/$id'
      preLoaderRoute: typeof DashboardSiteIdImport
      parentRoute: typeof DashboardImport
    }
    '/_dashboard/admin/': {
      id: '/_dashboard/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof DashboardAdminIndexImport
      parentRoute: typeof DashboardAdminImport
    }
    '/_dashboard/energy-monitoring/': {
      id: '/_dashboard/energy-monitoring/'
      path: '/energy-monitoring'
      fullPath: '/energy-monitoring'
      preLoaderRoute: typeof DashboardEnergyMonitoringIndexImport
      parentRoute: typeof DashboardImport
    }
    '/_dashboard/energy-usage/': {
      id: '/_dashboard/energy-usage/'
      path: '/energy-usage'
      fullPath: '/energy-usage'
      preLoaderRoute: typeof DashboardEnergyUsageIndexImport
      parentRoute: typeof DashboardImport
    }
    '/_dashboard/my-actions/': {
      id: '/_dashboard/my-actions/'
      path: '/my-actions'
      fullPath: '/my-actions'
      preLoaderRoute: typeof DashboardMyActionsIndexImport
      parentRoute: typeof DashboardImport
    }
    '/_dashboard/my-sites/': {
      id: '/_dashboard/my-sites/'
      path: '/my-sites'
      fullPath: '/my-sites'
      preLoaderRoute: typeof DashboardMySitesIndexImport
      parentRoute: typeof DashboardImport
    }
    '/_dashboard/tutorials/': {
      id: '/_dashboard/tutorials/'
      path: '/tutorials'
      fullPath: '/tutorials'
      preLoaderRoute: typeof DashboardTutorialsIndexImport
      parentRoute: typeof DashboardImport
    }
    '/_dashboard/users/': {
      id: '/_dashboard/users/'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof DashboardUsersIndexImport
      parentRoute: typeof DashboardImport
    }
    '/_dashboard/admin/dynamic-heat-curve/': {
      id: '/_dashboard/admin/dynamic-heat-curve/'
      path: '/dynamic-heat-curve'
      fullPath: '/admin/dynamic-heat-curve'
      preLoaderRoute: typeof DashboardAdminDynamicHeatCurveIndexImport
      parentRoute: typeof DashboardAdminImport
    }
    '/_dashboard/admin/heat-curve-default/': {
      id: '/_dashboard/admin/heat-curve-default/'
      path: '/heat-curve-default'
      fullPath: '/admin/heat-curve-default'
      preLoaderRoute: typeof DashboardAdminHeatCurveDefaultIndexImport
      parentRoute: typeof DashboardAdminImport
    }
    '/_dashboard/admin/sidebar-sections/': {
      id: '/_dashboard/admin/sidebar-sections/'
      path: '/sidebar-sections'
      fullPath: '/admin/sidebar-sections'
      preLoaderRoute: typeof DashboardAdminSidebarSectionsIndexImport
      parentRoute: typeof DashboardAdminImport
    }
    '/_dashboard/admin/synoptics/': {
      id: '/_dashboard/admin/synoptics/'
      path: '/synoptics'
      fullPath: '/admin/synoptics'
      preLoaderRoute: typeof DashboardAdminSynopticsIndexImport
      parentRoute: typeof DashboardAdminImport
    }
    '/_dashboard/air-quality/conformity/': {
      id: '/_dashboard/air-quality/conformity/'
      path: '/air-quality/conformity'
      fullPath: '/air-quality/conformity'
      preLoaderRoute: typeof DashboardAirQualityConformityIndexImport
      parentRoute: typeof DashboardImport
    }
    '/_dashboard/air-quality/history/': {
      id: '/_dashboard/air-quality/history/'
      path: '/air-quality/history'
      fullPath: '/air-quality/history'
      preLoaderRoute: typeof DashboardAirQualityHistoryIndexImport
      parentRoute: typeof DashboardImport
    }
    '/_dashboard/air-quality/map/': {
      id: '/_dashboard/air-quality/map/'
      path: '/air-quality/map'
      fullPath: '/air-quality/map'
      preLoaderRoute: typeof DashboardAirQualityMapIndexImport
      parentRoute: typeof DashboardImport
    }
    '/_dashboard/air-quality/settings/': {
      id: '/_dashboard/air-quality/settings/'
      path: '/air-quality/settings'
      fullPath: '/air-quality/settings'
      preLoaderRoute: typeof DashboardAirQualitySettingsIndexImport
      parentRoute: typeof DashboardImport
    }
    '/_dashboard/comfort/temperature/': {
      id: '/_dashboard/comfort/temperature/'
      path: '/comfort/temperature'
      fullPath: '/comfort/temperature'
      preLoaderRoute: typeof DashboardComfortTemperatureIndexImport
      parentRoute: typeof DashboardImport
    }
    '/_dashboard/company/settings/': {
      id: '/_dashboard/company/settings/'
      path: '/company/settings'
      fullPath: '/company/settings'
      preLoaderRoute: typeof DashboardCompanySettingsIndexImport
      parentRoute: typeof DashboardImport
    }
    '/_dashboard/energy-monitoring/air-handling-unit/': {
      id: '/_dashboard/energy-monitoring/air-handling-unit/'
      path: '/energy-monitoring/air-handling-unit'
      fullPath: '/energy-monitoring/air-handling-unit'
      preLoaderRoute: typeof DashboardEnergyMonitoringAirHandlingUnitIndexImport
      parentRoute: typeof DashboardImport
    }
    '/_dashboard/energy-monitoring/heating/': {
      id: '/_dashboard/energy-monitoring/heating/'
      path: '/energy-monitoring/heating'
      fullPath: '/energy-monitoring/heating'
      preLoaderRoute: typeof DashboardEnergyMonitoringHeatingIndexImport
      parentRoute: typeof DashboardImport
    }
    '/_dashboard/energy-usage/dashboard/': {
      id: '/_dashboard/energy-usage/dashboard/'
      path: '/energy-usage/dashboard'
      fullPath: '/energy-usage/dashboard'
      preLoaderRoute: typeof DashboardEnergyUsageDashboardIndexImport
      parentRoute: typeof DashboardImport
    }
    '/_dashboard/energy-usage/evolution/': {
      id: '/_dashboard/energy-usage/evolution/'
      path: '/energy-usage/evolution'
      fullPath: '/energy-usage/evolution'
      preLoaderRoute: typeof DashboardEnergyUsageEvolutionIndexImport
      parentRoute: typeof DashboardImport
    }
    '/_dashboard/energy-usage/location-analysis/': {
      id: '/_dashboard/energy-usage/location-analysis/'
      path: '/energy-usage/location-analysis'
      fullPath: '/energy-usage/location-analysis'
      preLoaderRoute: typeof DashboardEnergyUsageLocationAnalysisIndexImport
      parentRoute: typeof DashboardImport
    }
    '/_dashboard/energy-usage/meter-analysis/': {
      id: '/_dashboard/energy-usage/meter-analysis/'
      path: '/energy-usage/meter-analysis'
      fullPath: '/energy-usage/meter-analysis'
      preLoaderRoute: typeof DashboardEnergyUsageMeterAnalysisIndexImport
      parentRoute: typeof DashboardImport
    }
    '/_dashboard/energy-usage/production/': {
      id: '/_dashboard/energy-usage/production/'
      path: '/energy-usage/production'
      fullPath: '/energy-usage/production'
      preLoaderRoute: typeof DashboardEnergyUsageProductionIndexImport
      parentRoute: typeof DashboardImport
    }
    '/_dashboard/users/create/': {
      id: '/_dashboard/users/create/'
      path: '/users/create'
      fullPath: '/users/create'
      preLoaderRoute: typeof DashboardUsersCreateIndexImport
      parentRoute: typeof DashboardImport
    }
    '/_dashboard/my-sites/create/': {
      id: '/_dashboard/my-sites/create/'
      path: '/my-sites/create'
      fullPath: '/my-sites/create'
      preLoaderRoute: typeof DashboardMySitesCreateIndexLazyImport
      parentRoute: typeof DashboardImport
    }
    '/_dashboard/admin/synoptics/$id/': {
      id: '/_dashboard/admin/synoptics/$id/'
      path: '/synoptics/$id'
      fullPath: '/admin/synoptics/$id'
      preLoaderRoute: typeof DashboardAdminSynopticsIdIndexImport
      parentRoute: typeof DashboardAdminImport
    }
    '/_dashboard/admin/synoptics/create/': {
      id: '/_dashboard/admin/synoptics/create/'
      path: '/synoptics/create'
      fullPath: '/admin/synoptics/create'
      preLoaderRoute: typeof DashboardAdminSynopticsCreateIndexImport
      parentRoute: typeof DashboardAdminImport
    }
    '/_dashboard/air-quality/map/$floorId/': {
      id: '/_dashboard/air-quality/map/$floorId/'
      path: '/air-quality/map/$floorId'
      fullPath: '/air-quality/map/$floorId'
      preLoaderRoute: typeof DashboardAirQualityMapFloorIdIndexImport
      parentRoute: typeof DashboardImport
    }
    '/_dashboard/site/$id/actions-assignation/': {
      id: '/_dashboard/site/$id/actions-assignation/'
      path: '/actions-assignation'
      fullPath: '/site/$id/actions-assignation'
      preLoaderRoute: typeof DashboardSiteIdActionsAssignationIndexImport
      parentRoute: typeof DashboardSiteIdImport
    }
    '/_dashboard/site/$id/actions-done/': {
      id: '/_dashboard/site/$id/actions-done/'
      path: '/actions-done'
      fullPath: '/site/$id/actions-done'
      preLoaderRoute: typeof DashboardSiteIdActionsDoneIndexImport
      parentRoute: typeof DashboardSiteIdImport
    }
    '/_dashboard/site/$id/alarms/': {
      id: '/_dashboard/site/$id/alarms/'
      path: '/alarms'
      fullPath: '/site/$id/alarms'
      preLoaderRoute: typeof DashboardSiteIdAlarmsIndexImport
      parentRoute: typeof DashboardSiteIdImport
    }
    '/_dashboard/site/$id/alerts/': {
      id: '/_dashboard/site/$id/alerts/'
      path: '/alerts'
      fullPath: '/site/$id/alerts'
      preLoaderRoute: typeof DashboardSiteIdAlertsIndexImport
      parentRoute: typeof DashboardSiteIdImport
    }
    '/_dashboard/site/$id/defaults/': {
      id: '/_dashboard/site/$id/defaults/'
      path: '/defaults'
      fullPath: '/site/$id/defaults'
      preLoaderRoute: typeof DashboardSiteIdDefaultsIndexImport
      parentRoute: typeof DashboardSiteIdImport
    }
    '/_dashboard/site/$id/devices/': {
      id: '/_dashboard/site/$id/devices/'
      path: '/devices'
      fullPath: '/site/$id/devices'
      preLoaderRoute: typeof DashboardSiteIdDevicesIndexImport
      parentRoute: typeof DashboardSiteIdImport
    }
    '/_dashboard/site/$id/electrical/': {
      id: '/_dashboard/site/$id/electrical/'
      path: '/electrical'
      fullPath: '/site/$id/electrical'
      preLoaderRoute: typeof DashboardSiteIdElectricalIndexImport
      parentRoute: typeof DashboardSiteIdImport
    }
    '/_dashboard/site/$id/equipment/': {
      id: '/_dashboard/site/$id/equipment/'
      path: '/equipment'
      fullPath: '/site/$id/equipment'
      preLoaderRoute: typeof DashboardSiteIdEquipmentIndexImport
      parentRoute: typeof DashboardSiteIdImport
    }
    '/_dashboard/site/$id/information/': {
      id: '/_dashboard/site/$id/information/'
      path: '/information'
      fullPath: '/site/$id/information'
      preLoaderRoute: typeof DashboardSiteIdInformationIndexImport
      parentRoute: typeof DashboardSiteIdImport
    }
    '/_dashboard/site/$id/lighting/': {
      id: '/_dashboard/site/$id/lighting/'
      path: '/lighting'
      fullPath: '/site/$id/lighting'
      preLoaderRoute: typeof DashboardSiteIdLightingIndexImport
      parentRoute: typeof DashboardSiteIdImport
    }
    '/_dashboard/site/$id/logbook/': {
      id: '/_dashboard/site/$id/logbook/'
      path: '/logbook'
      fullPath: '/site/$id/logbook'
      preLoaderRoute: typeof DashboardSiteIdLogbookIndexImport
      parentRoute: typeof DashboardSiteIdImport
    }
    '/_dashboard/site/$id/medical-fluid/': {
      id: '/_dashboard/site/$id/medical-fluid/'
      path: '/medical-fluid'
      fullPath: '/site/$id/medical-fluid'
      preLoaderRoute: typeof DashboardSiteIdMedicalFluidIndexImport
      parentRoute: typeof DashboardSiteIdImport
    }
    '/_dashboard/site/$id/monitoring/': {
      id: '/_dashboard/site/$id/monitoring/'
      path: '/monitoring'
      fullPath: '/site/$id/monitoring'
      preLoaderRoute: typeof DashboardSiteIdMonitoringIndexImport
      parentRoute: typeof DashboardSiteIdImport
    }
    '/_dashboard/site/$id/my-actions/': {
      id: '/_dashboard/site/$id/my-actions/'
      path: '/my-actions'
      fullPath: '/site/$id/my-actions'
      preLoaderRoute: typeof DashboardSiteIdMyActionsIndexImport
      parentRoute: typeof DashboardSiteIdImport
    }
    '/_dashboard/site/$id/non-conformity/': {
      id: '/_dashboard/site/$id/non-conformity/'
      path: '/non-conformity'
      fullPath: '/site/$id/non-conformity'
      preLoaderRoute: typeof DashboardSiteIdNonConformityIndexImport
      parentRoute: typeof DashboardSiteIdImport
    }
    '/_dashboard/site/$id/reports/': {
      id: '/_dashboard/site/$id/reports/'
      path: '/reports'
      fullPath: '/site/$id/reports'
      preLoaderRoute: typeof DashboardSiteIdReportsIndexImport
      parentRoute: typeof DashboardSiteIdImport
    }
    '/_dashboard/site/$id/sensor-plan/': {
      id: '/_dashboard/site/$id/sensor-plan/'
      path: '/sensor-plan'
      fullPath: '/site/$id/sensor-plan'
      preLoaderRoute: typeof DashboardSiteIdSensorPlanIndexImport
      parentRoute: typeof DashboardSiteIdImport
    }
    '/_dashboard/users/edit/$userId/': {
      id: '/_dashboard/users/edit/$userId/'
      path: '/users/edit/$userId'
      fullPath: '/users/edit/$userId'
      preLoaderRoute: typeof DashboardUsersEditUserIdIndexImport
      parentRoute: typeof DashboardImport
    }
    '/_dashboard/site/$id/equipment/$equipmentId': {
      id: '/_dashboard/site/$id/equipment/$equipmentId'
      path: '/equipment/$equipmentId'
      fullPath: '/site/$id/equipment/$equipmentId'
      preLoaderRoute: typeof DashboardSiteIdEquipmentEquipmentIdImport
      parentRoute: typeof DashboardSiteIdImport
    }
    '/_dashboard/site/$id/equipment/$equipmentId/_layout': {
      id: '/_dashboard/site/$id/equipment/$equipmentId/_layout'
      path: '/equipment/$equipmentId'
      fullPath: '/site/$id/equipment/$equipmentId'
      preLoaderRoute: typeof DashboardSiteIdEquipmentEquipmentIdLayoutImport
      parentRoute: typeof DashboardSiteIdEquipmentEquipmentIdRoute
    }
    '/_dashboard/site/$id/actions-done/$actionId/': {
      id: '/_dashboard/site/$id/actions-done/$actionId/'
      path: '/actions-done/$actionId'
      fullPath: '/site/$id/actions-done/$actionId'
      preLoaderRoute: typeof DashboardSiteIdActionsDoneActionIdIndexImport
      parentRoute: typeof DashboardSiteIdImport
    }
    '/_dashboard/site/$id/alarms/$equipmentId/': {
      id: '/_dashboard/site/$id/alarms/$equipmentId/'
      path: '/alarms/$equipmentId'
      fullPath: '/site/$id/alarms/$equipmentId'
      preLoaderRoute: typeof DashboardSiteIdAlarmsEquipmentIdIndexImport
      parentRoute: typeof DashboardSiteIdImport
    }
    '/_dashboard/site/$id/alerts/create/': {
      id: '/_dashboard/site/$id/alerts/create/'
      path: '/alerts/create'
      fullPath: '/site/$id/alerts/create'
      preLoaderRoute: typeof DashboardSiteIdAlertsCreateIndexImport
      parentRoute: typeof DashboardSiteIdImport
    }
    '/_dashboard/site/$id/boiler-room/technical/': {
      id: '/_dashboard/site/$id/boiler-room/technical/'
      path: '/boiler-room/technical'
      fullPath: '/site/$id/boiler-room/technical'
      preLoaderRoute: typeof DashboardSiteIdBoilerRoomTechnicalIndexImport
      parentRoute: typeof DashboardSiteIdImport
    }
    '/_dashboard/site/$id/comfort/monitoring/': {
      id: '/_dashboard/site/$id/comfort/monitoring/'
      path: '/comfort/monitoring'
      fullPath: '/site/$id/comfort/monitoring'
      preLoaderRoute: typeof DashboardSiteIdComfortMonitoringIndexImport
      parentRoute: typeof DashboardSiteIdImport
    }
    '/_dashboard/site/$id/dashboard/general/': {
      id: '/_dashboard/site/$id/dashboard/general/'
      path: '/dashboard/general'
      fullPath: '/site/$id/dashboard/general'
      preLoaderRoute: typeof DashboardSiteIdDashboardGeneralIndexImport
      parentRoute: typeof DashboardSiteIdImport
    }
    '/_dashboard/site/$id/dashboard/recommendations/': {
      id: '/_dashboard/site/$id/dashboard/recommendations/'
      path: '/dashboard/recommendations'
      fullPath: '/site/$id/dashboard/recommendations'
      preLoaderRoute: typeof DashboardSiteIdDashboardRecommendationsIndexImport
      parentRoute: typeof DashboardSiteIdImport
    }
    '/_dashboard/site/$id/defaults/$equipmentId/': {
      id: '/_dashboard/site/$id/defaults/$equipmentId/'
      path: '/defaults/$equipmentId'
      fullPath: '/site/$id/defaults/$equipmentId'
      preLoaderRoute: typeof DashboardSiteIdDefaultsEquipmentIdIndexImport
      parentRoute: typeof DashboardSiteIdImport
    }
    '/_dashboard/site/$id/drift/equipment/': {
      id: '/_dashboard/site/$id/drift/equipment/'
      path: '/drift/equipment'
      fullPath: '/site/$id/drift/equipment'
      preLoaderRoute: typeof DashboardSiteIdDriftEquipmentIndexImport
      parentRoute: typeof DashboardSiteIdImport
    }
    '/_dashboard/site/$id/drift/settings/': {
      id: '/_dashboard/site/$id/drift/settings/'
      path: '/drift/settings'
      fullPath: '/site/$id/drift/settings'
      preLoaderRoute: typeof DashboardSiteIdDriftSettingsIndexImport
      parentRoute: typeof DashboardSiteIdImport
    }
    '/_dashboard/site/$id/electrical/$floorId/': {
      id: '/_dashboard/site/$id/electrical/$floorId/'
      path: '/electrical/$floorId'
      fullPath: '/site/$id/electrical/$floorId'
      preLoaderRoute: typeof DashboardSiteIdElectricalFloorIdIndexImport
      parentRoute: typeof DashboardSiteIdImport
    }
    '/_dashboard/site/$id/equipment/choose-sample/': {
      id: '/_dashboard/site/$id/equipment/choose-sample/'
      path: '/equipment/choose-sample'
      fullPath: '/site/$id/equipment/choose-sample'
      preLoaderRoute: typeof DashboardSiteIdEquipmentChooseSampleIndexImport
      parentRoute: typeof DashboardSiteIdImport
    }
    '/_dashboard/site/$id/equipment/create/': {
      id: '/_dashboard/site/$id/equipment/create/'
      path: '/equipment/create'
      fullPath: '/site/$id/equipment/create'
      preLoaderRoute: typeof DashboardSiteIdEquipmentCreateIndexImport
      parentRoute: typeof DashboardSiteIdImport
    }
    '/_dashboard/site/$id/equipment/energy/': {
      id: '/_dashboard/site/$id/equipment/energy/'
      path: '/equipment/energy'
      fullPath: '/site/$id/equipment/energy'
      preLoaderRoute: typeof DashboardSiteIdEquipmentEnergyIndexImport
      parentRoute: typeof DashboardSiteIdImport
    }
    '/_dashboard/site/$id/heat-pump/mode/': {
      id: '/_dashboard/site/$id/heat-pump/mode/'
      path: '/heat-pump/mode'
      fullPath: '/site/$id/heat-pump/mode'
      preLoaderRoute: typeof DashboardSiteIdHeatPumpModeIndexImport
      parentRoute: typeof DashboardSiteIdImport
    }
    '/_dashboard/site/$id/heat-pump/technical/': {
      id: '/_dashboard/site/$id/heat-pump/technical/'
      path: '/heat-pump/technical'
      fullPath: '/site/$id/heat-pump/technical'
      preLoaderRoute: typeof DashboardSiteIdHeatPumpTechnicalIndexImport
      parentRoute: typeof DashboardSiteIdImport
    }
    '/_dashboard/site/$id/information/add-work/': {
      id: '/_dashboard/site/$id/information/add-work/'
      path: '/information/add-work'
      fullPath: '/site/$id/information/add-work'
      preLoaderRoute: typeof DashboardSiteIdInformationAddWorkIndexImport
      parentRoute: typeof DashboardSiteIdImport
    }
    '/_dashboard/site/$id/lighting/$floorId/': {
      id: '/_dashboard/site/$id/lighting/$floorId/'
      path: '/lighting/$floorId'
      fullPath: '/site/$id/lighting/$floorId'
      preLoaderRoute: typeof DashboardSiteIdLightingFloorIdIndexImport
      parentRoute: typeof DashboardSiteIdImport
    }
    '/_dashboard/site/$id/logbook/$workId/': {
      id: '/_dashboard/site/$id/logbook/$workId/'
      path: '/logbook/$workId'
      fullPath: '/site/$id/logbook/$workId'
      preLoaderRoute: typeof DashboardSiteIdLogbookWorkIdIndexImport
      parentRoute: typeof DashboardSiteIdImport
    }
    '/_dashboard/site/$id/logbook/add-log/': {
      id: '/_dashboard/site/$id/logbook/add-log/'
      path: '/logbook/add-log'
      fullPath: '/site/$id/logbook/add-log'
      preLoaderRoute: typeof DashboardSiteIdLogbookAddLogIndexImport
      parentRoute: typeof DashboardSiteIdImport
    }
    '/_dashboard/site/$id/medical-fluid/$floorId/': {
      id: '/_dashboard/site/$id/medical-fluid/$floorId/'
      path: '/medical-fluid/$floorId'
      fullPath: '/site/$id/medical-fluid/$floorId'
      preLoaderRoute: typeof DashboardSiteIdMedicalFluidFloorIdIndexImport
      parentRoute: typeof DashboardSiteIdImport
    }
    '/_dashboard/site/$id/monitoring/$deviceId/': {
      id: '/_dashboard/site/$id/monitoring/$deviceId/'
      path: '/monitoring/$deviceId'
      fullPath: '/site/$id/monitoring/$deviceId'
      preLoaderRoute: typeof DashboardSiteIdMonitoringDeviceIdIndexImport
      parentRoute: typeof DashboardSiteIdImport
    }
    '/_dashboard/site/$id/my-actions/$actionId/': {
      id: '/_dashboard/site/$id/my-actions/$actionId/'
      path: '/my-actions/$actionId'
      fullPath: '/site/$id/my-actions/$actionId'
      preLoaderRoute: typeof DashboardSiteIdMyActionsActionIdIndexImport
      parentRoute: typeof DashboardSiteIdImport
    }
    '/_dashboard/site/$id/non-conformity/$actionId/': {
      id: '/_dashboard/site/$id/non-conformity/$actionId/'
      path: '/non-conformity/$actionId'
      fullPath: '/site/$id/non-conformity/$actionId'
      preLoaderRoute: typeof DashboardSiteIdNonConformityActionIdIndexImport
      parentRoute: typeof DashboardSiteIdImport
    }
    '/_dashboard/site/$id/operation/scheduler/': {
      id: '/_dashboard/site/$id/operation/scheduler/'
      path: '/operation/scheduler'
      fullPath: '/site/$id/operation/scheduler'
      preLoaderRoute: typeof DashboardSiteIdOperationSchedulerIndexImport
      parentRoute: typeof DashboardSiteIdImport
    }
    '/_dashboard/site/$id/sensor-plan/$floorId/': {
      id: '/_dashboard/site/$id/sensor-plan/$floorId/'
      path: '/sensor-plan/$floorId'
      fullPath: '/site/$id/sensor-plan/$floorId'
      preLoaderRoute: typeof DashboardSiteIdSensorPlanFloorIdIndexImport
      parentRoute: typeof DashboardSiteIdImport
    }
    '/_dashboard/site/$id/vmc/technical/': {
      id: '/_dashboard/site/$id/vmc/technical/'
      path: '/vmc/technical'
      fullPath: '/site/$id/vmc/technical'
      preLoaderRoute: typeof DashboardSiteIdVmcTechnicalIndexImport
      parentRoute: typeof DashboardSiteIdImport
    }
    '/_dashboard/site/$id/equipment/$equipmentId/_layout/actions': {
      id: '/_dashboard/site/$id/equipment/$equipmentId/_layout/actions'
      path: '/actions'
      fullPath: '/site/$id/equipment/$equipmentId/actions'
      preLoaderRoute: typeof DashboardSiteIdEquipmentEquipmentIdLayoutActionsImport
      parentRoute: typeof DashboardSiteIdEquipmentEquipmentIdLayoutImport
    }
    '/_dashboard/site/$id/equipment/$equipmentId/_layout/devices': {
      id: '/_dashboard/site/$id/equipment/$equipmentId/_layout/devices'
      path: '/devices'
      fullPath: '/site/$id/equipment/$equipmentId/devices'
      preLoaderRoute: typeof DashboardSiteIdEquipmentEquipmentIdLayoutDevicesImport
      parentRoute: typeof DashboardSiteIdEquipmentEquipmentIdLayoutImport
    }
    '/_dashboard/site/$id/equipment/$equipmentId/_layout/information': {
      id: '/_dashboard/site/$id/equipment/$equipmentId/_layout/information'
      path: '/information'
      fullPath: '/site/$id/equipment/$equipmentId/information'
      preLoaderRoute: typeof DashboardSiteIdEquipmentEquipmentIdLayoutInformationImport
      parentRoute: typeof DashboardSiteIdEquipmentEquipmentIdLayoutImport
    }
    '/_dashboard/site/$id/alerts/edit/$alertId/': {
      id: '/_dashboard/site/$id/alerts/edit/$alertId/'
      path: '/alerts/edit/$alertId'
      fullPath: '/site/$id/alerts/edit/$alertId'
      preLoaderRoute: typeof DashboardSiteIdAlertsEditAlertIdIndexImport
      parentRoute: typeof DashboardSiteIdImport
    }
    '/_dashboard/site/$id/alerts/edit/device-disconnected/': {
      id: '/_dashboard/site/$id/alerts/edit/device-disconnected/'
      path: '/alerts/edit/device-disconnected'
      fullPath: '/site/$id/alerts/edit/device-disconnected'
      preLoaderRoute: typeof DashboardSiteIdAlertsEditDeviceDisconnectedIndexImport
      parentRoute: typeof DashboardSiteIdImport
    }
    '/_dashboard/site/$id/boiler-room/technical/generate/': {
      id: '/_dashboard/site/$id/boiler-room/technical/generate/'
      path: '/boiler-room/technical/generate'
      fullPath: '/site/$id/boiler-room/technical/generate'
      preLoaderRoute: typeof DashboardSiteIdBoilerRoomTechnicalGenerateIndexImport
      parentRoute: typeof DashboardSiteIdImport
    }
    '/_dashboard/site/$id/boiler-room/technical/manage/': {
      id: '/_dashboard/site/$id/boiler-room/technical/manage/'
      path: '/boiler-room/technical/manage'
      fullPath: '/site/$id/boiler-room/technical/manage'
      preLoaderRoute: typeof DashboardSiteIdBoilerRoomTechnicalManageIndexImport
      parentRoute: typeof DashboardSiteIdImport
    }
    '/_dashboard/site/$id/comfort/monitoring/$floorId/': {
      id: '/_dashboard/site/$id/comfort/monitoring/$floorId/'
      path: '/comfort/monitoring/$floorId'
      fullPath: '/site/$id/comfort/monitoring/$floorId'
      preLoaderRoute: typeof DashboardSiteIdComfortMonitoringFloorIdIndexImport
      parentRoute: typeof DashboardSiteIdImport
    }
    '/_dashboard/site/$id/comfort/monitoring/configuration/': {
      id: '/_dashboard/site/$id/comfort/monitoring/configuration/'
      path: '/comfort/monitoring/configuration'
      fullPath: '/site/$id/comfort/monitoring/configuration'
      preLoaderRoute: typeof DashboardSiteIdComfortMonitoringConfigurationIndexImport
      parentRoute: typeof DashboardSiteIdImport
    }
    '/_dashboard/site/$id/devices/edit/$deviceId/': {
      id: '/_dashboard/site/$id/devices/edit/$deviceId/'
      path: '/devices/edit/$deviceId'
      fullPath: '/site/$id/devices/edit/$deviceId'
      preLoaderRoute: typeof DashboardSiteIdDevicesEditDeviceIdIndexImport
      parentRoute: typeof DashboardSiteIdImport
    }
    '/_dashboard/site/$id/equipment/energy/$equipmentId/': {
      id: '/_dashboard/site/$id/equipment/energy/$equipmentId/'
      path: '/equipment/energy/$equipmentId'
      fullPath: '/site/$id/equipment/energy/$equipmentId'
      preLoaderRoute: typeof DashboardSiteIdEquipmentEnergyEquipmentIdIndexImport
      parentRoute: typeof DashboardSiteIdImport
    }
    '/_dashboard/site/$id/heat-pump/technical/generate/': {
      id: '/_dashboard/site/$id/heat-pump/technical/generate/'
      path: '/heat-pump/technical/generate'
      fullPath: '/site/$id/heat-pump/technical/generate'
      preLoaderRoute: typeof DashboardSiteIdHeatPumpTechnicalGenerateIndexImport
      parentRoute: typeof DashboardSiteIdImport
    }
    '/_dashboard/site/$id/heat-pump/technical/manage/': {
      id: '/_dashboard/site/$id/heat-pump/technical/manage/'
      path: '/heat-pump/technical/manage'
      fullPath: '/site/$id/heat-pump/technical/manage'
      preLoaderRoute: typeof DashboardSiteIdHeatPumpTechnicalManageIndexImport
      parentRoute: typeof DashboardSiteIdImport
    }
    '/_dashboard/site/$id/information/work/$workId/': {
      id: '/_dashboard/site/$id/information/work/$workId/'
      path: '/information/work/$workId'
      fullPath: '/site/$id/information/work/$workId'
      preLoaderRoute: typeof DashboardSiteIdInformationWorkWorkIdIndexImport
      parentRoute: typeof DashboardSiteIdImport
    }
    '/_dashboard/site/$id/operation/scheduler/$scheduleId/': {
      id: '/_dashboard/site/$id/operation/scheduler/$scheduleId/'
      path: '/operation/scheduler/$scheduleId'
      fullPath: '/site/$id/operation/scheduler/$scheduleId'
      preLoaderRoute: typeof DashboardSiteIdOperationSchedulerScheduleIdIndexImport
      parentRoute: typeof DashboardSiteIdImport
    }
    '/_dashboard/site/$id/operation/scheduler/create/': {
      id: '/_dashboard/site/$id/operation/scheduler/create/'
      path: '/operation/scheduler/create'
      fullPath: '/site/$id/operation/scheduler/create'
      preLoaderRoute: typeof DashboardSiteIdOperationSchedulerCreateIndexImport
      parentRoute: typeof DashboardSiteIdImport
    }
    '/_dashboard/site/$id/reports/configuration/create/': {
      id: '/_dashboard/site/$id/reports/configuration/create/'
      path: '/reports/configuration/create'
      fullPath: '/site/$id/reports/configuration/create'
      preLoaderRoute: typeof DashboardSiteIdReportsConfigurationCreateIndexImport
      parentRoute: typeof DashboardSiteIdImport
    }
    '/_dashboard/site/$id/vmc/technical/manage/': {
      id: '/_dashboard/site/$id/vmc/technical/manage/'
      path: '/vmc/technical/manage'
      fullPath: '/site/$id/vmc/technical/manage'
      preLoaderRoute: typeof DashboardSiteIdVmcTechnicalManageIndexImport
      parentRoute: typeof DashboardSiteIdImport
    }
    '/_dashboard/site/$id/alerts/edit/$alertId/comment/': {
      id: '/_dashboard/site/$id/alerts/edit/$alertId/comment/'
      path: '/alerts/edit/$alertId/comment'
      fullPath: '/site/$id/alerts/edit/$alertId/comment'
      preLoaderRoute: typeof DashboardSiteIdAlertsEditAlertIdCommentIndexImport
      parentRoute: typeof DashboardSiteIdImport
    }
    '/_dashboard/site/$id/boiler-room/technical/manage/$synopticId/': {
      id: '/_dashboard/site/$id/boiler-room/technical/manage/$synopticId/'
      path: '/boiler-room/technical/manage/$synopticId'
      fullPath: '/site/$id/boiler-room/technical/manage/$synopticId'
      preLoaderRoute: typeof DashboardSiteIdBoilerRoomTechnicalManageSynopticIdIndexImport
      parentRoute: typeof DashboardSiteIdImport
    }
    '/_dashboard/site/$id/heat-pump/technical/manage/$synopticId/': {
      id: '/_dashboard/site/$id/heat-pump/technical/manage/$synopticId/'
      path: '/heat-pump/technical/manage/$synopticId'
      fullPath: '/site/$id/heat-pump/technical/manage/$synopticId'
      preLoaderRoute: typeof DashboardSiteIdHeatPumpTechnicalManageSynopticIdIndexImport
      parentRoute: typeof DashboardSiteIdImport
    }
    '/_dashboard/site/$id/operation/scheduler/cta/$zoneCtaId/': {
      id: '/_dashboard/site/$id/operation/scheduler/cta/$zoneCtaId/'
      path: '/operation/scheduler/cta/$zoneCtaId'
      fullPath: '/site/$id/operation/scheduler/cta/$zoneCtaId'
      preLoaderRoute: typeof DashboardSiteIdOperationSchedulerCtaZoneCtaIdIndexImport
      parentRoute: typeof DashboardSiteIdImport
    }
    '/_dashboard/site/$id/reports/configuration/edit/$reportId/': {
      id: '/_dashboard/site/$id/reports/configuration/edit/$reportId/'
      path: '/reports/configuration/edit/$reportId'
      fullPath: '/site/$id/reports/configuration/edit/$reportId'
      preLoaderRoute: typeof DashboardSiteIdReportsConfigurationEditReportIdIndexImport
      parentRoute: typeof DashboardSiteIdImport
    }
  }
}

// Create and export the route tree

interface AuthRouteChildren {
  AuthLoginRoute: typeof AuthLoginRoute
  AuthResetPasswordRoute: typeof AuthResetPasswordRoute
  AuthIndexRoute: typeof AuthIndexRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthLoginRoute: AuthLoginRoute,
  AuthResetPasswordRoute: AuthResetPasswordRoute,
  AuthIndexRoute: AuthIndexRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

interface DashboardAdminRouteChildren {
  DashboardAdminIndexRoute: typeof DashboardAdminIndexRoute
  DashboardAdminDynamicHeatCurveIndexRoute: typeof DashboardAdminDynamicHeatCurveIndexRoute
  DashboardAdminHeatCurveDefaultIndexRoute: typeof DashboardAdminHeatCurveDefaultIndexRoute
  DashboardAdminSidebarSectionsIndexRoute: typeof DashboardAdminSidebarSectionsIndexRoute
  DashboardAdminSynopticsIndexRoute: typeof DashboardAdminSynopticsIndexRoute
  DashboardAdminSynopticsIdIndexRoute: typeof DashboardAdminSynopticsIdIndexRoute
  DashboardAdminSynopticsCreateIndexRoute: typeof DashboardAdminSynopticsCreateIndexRoute
}

const DashboardAdminRouteChildren: DashboardAdminRouteChildren = {
  DashboardAdminIndexRoute: DashboardAdminIndexRoute,
  DashboardAdminDynamicHeatCurveIndexRoute:
    DashboardAdminDynamicHeatCurveIndexRoute,
  DashboardAdminHeatCurveDefaultIndexRoute:
    DashboardAdminHeatCurveDefaultIndexRoute,
  DashboardAdminSidebarSectionsIndexRoute:
    DashboardAdminSidebarSectionsIndexRoute,
  DashboardAdminSynopticsIndexRoute: DashboardAdminSynopticsIndexRoute,
  DashboardAdminSynopticsIdIndexRoute: DashboardAdminSynopticsIdIndexRoute,
  DashboardAdminSynopticsCreateIndexRoute:
    DashboardAdminSynopticsCreateIndexRoute,
}

const DashboardAdminRouteWithChildren = DashboardAdminRoute._addFileChildren(
  DashboardAdminRouteChildren,
)

interface DashboardSiteIdEquipmentEquipmentIdLayoutRouteChildren {
  DashboardSiteIdEquipmentEquipmentIdLayoutActionsRoute: typeof DashboardSiteIdEquipmentEquipmentIdLayoutActionsRoute
  DashboardSiteIdEquipmentEquipmentIdLayoutDevicesRoute: typeof DashboardSiteIdEquipmentEquipmentIdLayoutDevicesRoute
  DashboardSiteIdEquipmentEquipmentIdLayoutInformationRoute: typeof DashboardSiteIdEquipmentEquipmentIdLayoutInformationRoute
}

const DashboardSiteIdEquipmentEquipmentIdLayoutRouteChildren: DashboardSiteIdEquipmentEquipmentIdLayoutRouteChildren =
  {
    DashboardSiteIdEquipmentEquipmentIdLayoutActionsRoute:
      DashboardSiteIdEquipmentEquipmentIdLayoutActionsRoute,
    DashboardSiteIdEquipmentEquipmentIdLayoutDevicesRoute:
      DashboardSiteIdEquipmentEquipmentIdLayoutDevicesRoute,
    DashboardSiteIdEquipmentEquipmentIdLayoutInformationRoute:
      DashboardSiteIdEquipmentEquipmentIdLayoutInformationRoute,
  }

const DashboardSiteIdEquipmentEquipmentIdLayoutRouteWithChildren =
  DashboardSiteIdEquipmentEquipmentIdLayoutRoute._addFileChildren(
    DashboardSiteIdEquipmentEquipmentIdLayoutRouteChildren,
  )

interface DashboardSiteIdEquipmentEquipmentIdRouteChildren {
  DashboardSiteIdEquipmentEquipmentIdLayoutRoute: typeof DashboardSiteIdEquipmentEquipmentIdLayoutRouteWithChildren
}

const DashboardSiteIdEquipmentEquipmentIdRouteChildren: DashboardSiteIdEquipmentEquipmentIdRouteChildren =
  {
    DashboardSiteIdEquipmentEquipmentIdLayoutRoute:
      DashboardSiteIdEquipmentEquipmentIdLayoutRouteWithChildren,
  }

const DashboardSiteIdEquipmentEquipmentIdRouteWithChildren =
  DashboardSiteIdEquipmentEquipmentIdRoute._addFileChildren(
    DashboardSiteIdEquipmentEquipmentIdRouteChildren,
  )

interface DashboardSiteIdRouteChildren {
  DashboardSiteIdActionsAssignationIndexRoute: typeof DashboardSiteIdActionsAssignationIndexRoute
  DashboardSiteIdActionsDoneIndexRoute: typeof DashboardSiteIdActionsDoneIndexRoute
  DashboardSiteIdAlarmsIndexRoute: typeof DashboardSiteIdAlarmsIndexRoute
  DashboardSiteIdAlertsIndexRoute: typeof DashboardSiteIdAlertsIndexRoute
  DashboardSiteIdDefaultsIndexRoute: typeof DashboardSiteIdDefaultsIndexRoute
  DashboardSiteIdDevicesIndexRoute: typeof DashboardSiteIdDevicesIndexRoute
  DashboardSiteIdElectricalIndexRoute: typeof DashboardSiteIdElectricalIndexRoute
  DashboardSiteIdEquipmentIndexRoute: typeof DashboardSiteIdEquipmentIndexRoute
  DashboardSiteIdInformationIndexRoute: typeof DashboardSiteIdInformationIndexRoute
  DashboardSiteIdLightingIndexRoute: typeof DashboardSiteIdLightingIndexRoute
  DashboardSiteIdLogbookIndexRoute: typeof DashboardSiteIdLogbookIndexRoute
  DashboardSiteIdMedicalFluidIndexRoute: typeof DashboardSiteIdMedicalFluidIndexRoute
  DashboardSiteIdMonitoringIndexRoute: typeof DashboardSiteIdMonitoringIndexRoute
  DashboardSiteIdMyActionsIndexRoute: typeof DashboardSiteIdMyActionsIndexRoute
  DashboardSiteIdNonConformityIndexRoute: typeof DashboardSiteIdNonConformityIndexRoute
  DashboardSiteIdReportsIndexRoute: typeof DashboardSiteIdReportsIndexRoute
  DashboardSiteIdSensorPlanIndexRoute: typeof DashboardSiteIdSensorPlanIndexRoute
  DashboardSiteIdEquipmentEquipmentIdRoute: typeof DashboardSiteIdEquipmentEquipmentIdRouteWithChildren
  DashboardSiteIdActionsDoneActionIdIndexRoute: typeof DashboardSiteIdActionsDoneActionIdIndexRoute
  DashboardSiteIdAlarmsEquipmentIdIndexRoute: typeof DashboardSiteIdAlarmsEquipmentIdIndexRoute
  DashboardSiteIdAlertsCreateIndexRoute: typeof DashboardSiteIdAlertsCreateIndexRoute
  DashboardSiteIdBoilerRoomTechnicalIndexRoute: typeof DashboardSiteIdBoilerRoomTechnicalIndexRoute
  DashboardSiteIdComfortMonitoringIndexRoute: typeof DashboardSiteIdComfortMonitoringIndexRoute
  DashboardSiteIdDashboardGeneralIndexRoute: typeof DashboardSiteIdDashboardGeneralIndexRoute
  DashboardSiteIdDashboardRecommendationsIndexRoute: typeof DashboardSiteIdDashboardRecommendationsIndexRoute
  DashboardSiteIdDefaultsEquipmentIdIndexRoute: typeof DashboardSiteIdDefaultsEquipmentIdIndexRoute
  DashboardSiteIdDriftEquipmentIndexRoute: typeof DashboardSiteIdDriftEquipmentIndexRoute
  DashboardSiteIdDriftSettingsIndexRoute: typeof DashboardSiteIdDriftSettingsIndexRoute
  DashboardSiteIdElectricalFloorIdIndexRoute: typeof DashboardSiteIdElectricalFloorIdIndexRoute
  DashboardSiteIdEquipmentChooseSampleIndexRoute: typeof DashboardSiteIdEquipmentChooseSampleIndexRoute
  DashboardSiteIdEquipmentCreateIndexRoute: typeof DashboardSiteIdEquipmentCreateIndexRoute
  DashboardSiteIdEquipmentEnergyIndexRoute: typeof DashboardSiteIdEquipmentEnergyIndexRoute
  DashboardSiteIdHeatPumpModeIndexRoute: typeof DashboardSiteIdHeatPumpModeIndexRoute
  DashboardSiteIdHeatPumpTechnicalIndexRoute: typeof DashboardSiteIdHeatPumpTechnicalIndexRoute
  DashboardSiteIdInformationAddWorkIndexRoute: typeof DashboardSiteIdInformationAddWorkIndexRoute
  DashboardSiteIdLightingFloorIdIndexRoute: typeof DashboardSiteIdLightingFloorIdIndexRoute
  DashboardSiteIdLogbookWorkIdIndexRoute: typeof DashboardSiteIdLogbookWorkIdIndexRoute
  DashboardSiteIdLogbookAddLogIndexRoute: typeof DashboardSiteIdLogbookAddLogIndexRoute
  DashboardSiteIdMedicalFluidFloorIdIndexRoute: typeof DashboardSiteIdMedicalFluidFloorIdIndexRoute
  DashboardSiteIdMonitoringDeviceIdIndexRoute: typeof DashboardSiteIdMonitoringDeviceIdIndexRoute
  DashboardSiteIdMyActionsActionIdIndexRoute: typeof DashboardSiteIdMyActionsActionIdIndexRoute
  DashboardSiteIdNonConformityActionIdIndexRoute: typeof DashboardSiteIdNonConformityActionIdIndexRoute
  DashboardSiteIdOperationSchedulerIndexRoute: typeof DashboardSiteIdOperationSchedulerIndexRoute
  DashboardSiteIdSensorPlanFloorIdIndexRoute: typeof DashboardSiteIdSensorPlanFloorIdIndexRoute
  DashboardSiteIdVmcTechnicalIndexRoute: typeof DashboardSiteIdVmcTechnicalIndexRoute
  DashboardSiteIdAlertsEditAlertIdIndexRoute: typeof DashboardSiteIdAlertsEditAlertIdIndexRoute
  DashboardSiteIdAlertsEditDeviceDisconnectedIndexRoute: typeof DashboardSiteIdAlertsEditDeviceDisconnectedIndexRoute
  DashboardSiteIdBoilerRoomTechnicalGenerateIndexRoute: typeof DashboardSiteIdBoilerRoomTechnicalGenerateIndexRoute
  DashboardSiteIdBoilerRoomTechnicalManageIndexRoute: typeof DashboardSiteIdBoilerRoomTechnicalManageIndexRoute
  DashboardSiteIdComfortMonitoringFloorIdIndexRoute: typeof DashboardSiteIdComfortMonitoringFloorIdIndexRoute
  DashboardSiteIdComfortMonitoringConfigurationIndexRoute: typeof DashboardSiteIdComfortMonitoringConfigurationIndexRoute
  DashboardSiteIdDevicesEditDeviceIdIndexRoute: typeof DashboardSiteIdDevicesEditDeviceIdIndexRoute
  DashboardSiteIdEquipmentEnergyEquipmentIdIndexRoute: typeof DashboardSiteIdEquipmentEnergyEquipmentIdIndexRoute
  DashboardSiteIdHeatPumpTechnicalGenerateIndexRoute: typeof DashboardSiteIdHeatPumpTechnicalGenerateIndexRoute
  DashboardSiteIdHeatPumpTechnicalManageIndexRoute: typeof DashboardSiteIdHeatPumpTechnicalManageIndexRoute
  DashboardSiteIdInformationWorkWorkIdIndexRoute: typeof DashboardSiteIdInformationWorkWorkIdIndexRoute
  DashboardSiteIdOperationSchedulerScheduleIdIndexRoute: typeof DashboardSiteIdOperationSchedulerScheduleIdIndexRoute
  DashboardSiteIdOperationSchedulerCreateIndexRoute: typeof DashboardSiteIdOperationSchedulerCreateIndexRoute
  DashboardSiteIdReportsConfigurationCreateIndexRoute: typeof DashboardSiteIdReportsConfigurationCreateIndexRoute
  DashboardSiteIdVmcTechnicalManageIndexRoute: typeof DashboardSiteIdVmcTechnicalManageIndexRoute
  DashboardSiteIdAlertsEditAlertIdCommentIndexRoute: typeof DashboardSiteIdAlertsEditAlertIdCommentIndexRoute
  DashboardSiteIdBoilerRoomTechnicalManageSynopticIdIndexRoute: typeof DashboardSiteIdBoilerRoomTechnicalManageSynopticIdIndexRoute
  DashboardSiteIdHeatPumpTechnicalManageSynopticIdIndexRoute: typeof DashboardSiteIdHeatPumpTechnicalManageSynopticIdIndexRoute
  DashboardSiteIdOperationSchedulerCtaZoneCtaIdIndexRoute: typeof DashboardSiteIdOperationSchedulerCtaZoneCtaIdIndexRoute
  DashboardSiteIdReportsConfigurationEditReportIdIndexRoute: typeof DashboardSiteIdReportsConfigurationEditReportIdIndexRoute
}

const DashboardSiteIdRouteChildren: DashboardSiteIdRouteChildren = {
  DashboardSiteIdActionsAssignationIndexRoute:
    DashboardSiteIdActionsAssignationIndexRoute,
  DashboardSiteIdActionsDoneIndexRoute: DashboardSiteIdActionsDoneIndexRoute,
  DashboardSiteIdAlarmsIndexRoute: DashboardSiteIdAlarmsIndexRoute,
  DashboardSiteIdAlertsIndexRoute: DashboardSiteIdAlertsIndexRoute,
  DashboardSiteIdDefaultsIndexRoute: DashboardSiteIdDefaultsIndexRoute,
  DashboardSiteIdDevicesIndexRoute: DashboardSiteIdDevicesIndexRoute,
  DashboardSiteIdElectricalIndexRoute: DashboardSiteIdElectricalIndexRoute,
  DashboardSiteIdEquipmentIndexRoute: DashboardSiteIdEquipmentIndexRoute,
  DashboardSiteIdInformationIndexRoute: DashboardSiteIdInformationIndexRoute,
  DashboardSiteIdLightingIndexRoute: DashboardSiteIdLightingIndexRoute,
  DashboardSiteIdLogbookIndexRoute: DashboardSiteIdLogbookIndexRoute,
  DashboardSiteIdMedicalFluidIndexRoute: DashboardSiteIdMedicalFluidIndexRoute,
  DashboardSiteIdMonitoringIndexRoute: DashboardSiteIdMonitoringIndexRoute,
  DashboardSiteIdMyActionsIndexRoute: DashboardSiteIdMyActionsIndexRoute,
  DashboardSiteIdNonConformityIndexRoute:
    DashboardSiteIdNonConformityIndexRoute,
  DashboardSiteIdReportsIndexRoute: DashboardSiteIdReportsIndexRoute,
  DashboardSiteIdSensorPlanIndexRoute: DashboardSiteIdSensorPlanIndexRoute,
  DashboardSiteIdEquipmentEquipmentIdRoute:
    DashboardSiteIdEquipmentEquipmentIdRouteWithChildren,
  DashboardSiteIdActionsDoneActionIdIndexRoute:
    DashboardSiteIdActionsDoneActionIdIndexRoute,
  DashboardSiteIdAlarmsEquipmentIdIndexRoute:
    DashboardSiteIdAlarmsEquipmentIdIndexRoute,
  DashboardSiteIdAlertsCreateIndexRoute: DashboardSiteIdAlertsCreateIndexRoute,
  DashboardSiteIdBoilerRoomTechnicalIndexRoute:
    DashboardSiteIdBoilerRoomTechnicalIndexRoute,
  DashboardSiteIdComfortMonitoringIndexRoute:
    DashboardSiteIdComfortMonitoringIndexRoute,
  DashboardSiteIdDashboardGeneralIndexRoute:
    DashboardSiteIdDashboardGeneralIndexRoute,
  DashboardSiteIdDashboardRecommendationsIndexRoute:
    DashboardSiteIdDashboardRecommendationsIndexRoute,
  DashboardSiteIdDefaultsEquipmentIdIndexRoute:
    DashboardSiteIdDefaultsEquipmentIdIndexRoute,
  DashboardSiteIdDriftEquipmentIndexRoute:
    DashboardSiteIdDriftEquipmentIndexRoute,
  DashboardSiteIdDriftSettingsIndexRoute:
    DashboardSiteIdDriftSettingsIndexRoute,
  DashboardSiteIdElectricalFloorIdIndexRoute:
    DashboardSiteIdElectricalFloorIdIndexRoute,
  DashboardSiteIdEquipmentChooseSampleIndexRoute:
    DashboardSiteIdEquipmentChooseSampleIndexRoute,
  DashboardSiteIdEquipmentCreateIndexRoute:
    DashboardSiteIdEquipmentCreateIndexRoute,
  DashboardSiteIdEquipmentEnergyIndexRoute:
    DashboardSiteIdEquipmentEnergyIndexRoute,
  DashboardSiteIdHeatPumpModeIndexRoute: DashboardSiteIdHeatPumpModeIndexRoute,
  DashboardSiteIdHeatPumpTechnicalIndexRoute:
    DashboardSiteIdHeatPumpTechnicalIndexRoute,
  DashboardSiteIdInformationAddWorkIndexRoute:
    DashboardSiteIdInformationAddWorkIndexRoute,
  DashboardSiteIdLightingFloorIdIndexRoute:
    DashboardSiteIdLightingFloorIdIndexRoute,
  DashboardSiteIdLogbookWorkIdIndexRoute:
    DashboardSiteIdLogbookWorkIdIndexRoute,
  DashboardSiteIdLogbookAddLogIndexRoute:
    DashboardSiteIdLogbookAddLogIndexRoute,
  DashboardSiteIdMedicalFluidFloorIdIndexRoute:
    DashboardSiteIdMedicalFluidFloorIdIndexRoute,
  DashboardSiteIdMonitoringDeviceIdIndexRoute:
    DashboardSiteIdMonitoringDeviceIdIndexRoute,
  DashboardSiteIdMyActionsActionIdIndexRoute:
    DashboardSiteIdMyActionsActionIdIndexRoute,
  DashboardSiteIdNonConformityActionIdIndexRoute:
    DashboardSiteIdNonConformityActionIdIndexRoute,
  DashboardSiteIdOperationSchedulerIndexRoute:
    DashboardSiteIdOperationSchedulerIndexRoute,
  DashboardSiteIdSensorPlanFloorIdIndexRoute:
    DashboardSiteIdSensorPlanFloorIdIndexRoute,
  DashboardSiteIdVmcTechnicalIndexRoute: DashboardSiteIdVmcTechnicalIndexRoute,
  DashboardSiteIdAlertsEditAlertIdIndexRoute:
    DashboardSiteIdAlertsEditAlertIdIndexRoute,
  DashboardSiteIdAlertsEditDeviceDisconnectedIndexRoute:
    DashboardSiteIdAlertsEditDeviceDisconnectedIndexRoute,
  DashboardSiteIdBoilerRoomTechnicalGenerateIndexRoute:
    DashboardSiteIdBoilerRoomTechnicalGenerateIndexRoute,
  DashboardSiteIdBoilerRoomTechnicalManageIndexRoute:
    DashboardSiteIdBoilerRoomTechnicalManageIndexRoute,
  DashboardSiteIdComfortMonitoringFloorIdIndexRoute:
    DashboardSiteIdComfortMonitoringFloorIdIndexRoute,
  DashboardSiteIdComfortMonitoringConfigurationIndexRoute:
    DashboardSiteIdComfortMonitoringConfigurationIndexRoute,
  DashboardSiteIdDevicesEditDeviceIdIndexRoute:
    DashboardSiteIdDevicesEditDeviceIdIndexRoute,
  DashboardSiteIdEquipmentEnergyEquipmentIdIndexRoute:
    DashboardSiteIdEquipmentEnergyEquipmentIdIndexRoute,
  DashboardSiteIdHeatPumpTechnicalGenerateIndexRoute:
    DashboardSiteIdHeatPumpTechnicalGenerateIndexRoute,
  DashboardSiteIdHeatPumpTechnicalManageIndexRoute:
    DashboardSiteIdHeatPumpTechnicalManageIndexRoute,
  DashboardSiteIdInformationWorkWorkIdIndexRoute:
    DashboardSiteIdInformationWorkWorkIdIndexRoute,
  DashboardSiteIdOperationSchedulerScheduleIdIndexRoute:
    DashboardSiteIdOperationSchedulerScheduleIdIndexRoute,
  DashboardSiteIdOperationSchedulerCreateIndexRoute:
    DashboardSiteIdOperationSchedulerCreateIndexRoute,
  DashboardSiteIdReportsConfigurationCreateIndexRoute:
    DashboardSiteIdReportsConfigurationCreateIndexRoute,
  DashboardSiteIdVmcTechnicalManageIndexRoute:
    DashboardSiteIdVmcTechnicalManageIndexRoute,
  DashboardSiteIdAlertsEditAlertIdCommentIndexRoute:
    DashboardSiteIdAlertsEditAlertIdCommentIndexRoute,
  DashboardSiteIdBoilerRoomTechnicalManageSynopticIdIndexRoute:
    DashboardSiteIdBoilerRoomTechnicalManageSynopticIdIndexRoute,
  DashboardSiteIdHeatPumpTechnicalManageSynopticIdIndexRoute:
    DashboardSiteIdHeatPumpTechnicalManageSynopticIdIndexRoute,
  DashboardSiteIdOperationSchedulerCtaZoneCtaIdIndexRoute:
    DashboardSiteIdOperationSchedulerCtaZoneCtaIdIndexRoute,
  DashboardSiteIdReportsConfigurationEditReportIdIndexRoute:
    DashboardSiteIdReportsConfigurationEditReportIdIndexRoute,
}

const DashboardSiteIdRouteWithChildren = DashboardSiteIdRoute._addFileChildren(
  DashboardSiteIdRouteChildren,
)

interface DashboardRouteChildren {
  DashboardAdminRoute: typeof DashboardAdminRouteWithChildren
  DashboardSiteIdRoute: typeof DashboardSiteIdRouteWithChildren
  DashboardEnergyMonitoringIndexRoute: typeof DashboardEnergyMonitoringIndexRoute
  DashboardEnergyUsageIndexRoute: typeof DashboardEnergyUsageIndexRoute
  DashboardMyActionsIndexRoute: typeof DashboardMyActionsIndexRoute
  DashboardMySitesIndexRoute: typeof DashboardMySitesIndexRoute
  DashboardTutorialsIndexRoute: typeof DashboardTutorialsIndexRoute
  DashboardUsersIndexRoute: typeof DashboardUsersIndexRoute
  DashboardAirQualityConformityIndexRoute: typeof DashboardAirQualityConformityIndexRoute
  DashboardAirQualityHistoryIndexRoute: typeof DashboardAirQualityHistoryIndexRoute
  DashboardAirQualityMapIndexRoute: typeof DashboardAirQualityMapIndexRoute
  DashboardAirQualitySettingsIndexRoute: typeof DashboardAirQualitySettingsIndexRoute
  DashboardComfortTemperatureIndexRoute: typeof DashboardComfortTemperatureIndexRoute
  DashboardCompanySettingsIndexRoute: typeof DashboardCompanySettingsIndexRoute
  DashboardEnergyMonitoringAirHandlingUnitIndexRoute: typeof DashboardEnergyMonitoringAirHandlingUnitIndexRoute
  DashboardEnergyMonitoringHeatingIndexRoute: typeof DashboardEnergyMonitoringHeatingIndexRoute
  DashboardEnergyUsageDashboardIndexRoute: typeof DashboardEnergyUsageDashboardIndexRoute
  DashboardEnergyUsageEvolutionIndexRoute: typeof DashboardEnergyUsageEvolutionIndexRoute
  DashboardEnergyUsageLocationAnalysisIndexRoute: typeof DashboardEnergyUsageLocationAnalysisIndexRoute
  DashboardEnergyUsageMeterAnalysisIndexRoute: typeof DashboardEnergyUsageMeterAnalysisIndexRoute
  DashboardEnergyUsageProductionIndexRoute: typeof DashboardEnergyUsageProductionIndexRoute
  DashboardUsersCreateIndexRoute: typeof DashboardUsersCreateIndexRoute
  DashboardMySitesCreateIndexLazyRoute: typeof DashboardMySitesCreateIndexLazyRoute
  DashboardAirQualityMapFloorIdIndexRoute: typeof DashboardAirQualityMapFloorIdIndexRoute
  DashboardUsersEditUserIdIndexRoute: typeof DashboardUsersEditUserIdIndexRoute
}

const DashboardRouteChildren: DashboardRouteChildren = {
  DashboardAdminRoute: DashboardAdminRouteWithChildren,
  DashboardSiteIdRoute: DashboardSiteIdRouteWithChildren,
  DashboardEnergyMonitoringIndexRoute: DashboardEnergyMonitoringIndexRoute,
  DashboardEnergyUsageIndexRoute: DashboardEnergyUsageIndexRoute,
  DashboardMyActionsIndexRoute: DashboardMyActionsIndexRoute,
  DashboardMySitesIndexRoute: DashboardMySitesIndexRoute,
  DashboardTutorialsIndexRoute: DashboardTutorialsIndexRoute,
  DashboardUsersIndexRoute: DashboardUsersIndexRoute,
  DashboardAirQualityConformityIndexRoute:
    DashboardAirQualityConformityIndexRoute,
  DashboardAirQualityHistoryIndexRoute: DashboardAirQualityHistoryIndexRoute,
  DashboardAirQualityMapIndexRoute: DashboardAirQualityMapIndexRoute,
  DashboardAirQualitySettingsIndexRoute: DashboardAirQualitySettingsIndexRoute,
  DashboardComfortTemperatureIndexRoute: DashboardComfortTemperatureIndexRoute,
  DashboardCompanySettingsIndexRoute: DashboardCompanySettingsIndexRoute,
  DashboardEnergyMonitoringAirHandlingUnitIndexRoute:
    DashboardEnergyMonitoringAirHandlingUnitIndexRoute,
  DashboardEnergyMonitoringHeatingIndexRoute:
    DashboardEnergyMonitoringHeatingIndexRoute,
  DashboardEnergyUsageDashboardIndexRoute:
    DashboardEnergyUsageDashboardIndexRoute,
  DashboardEnergyUsageEvolutionIndexRoute:
    DashboardEnergyUsageEvolutionIndexRoute,
  DashboardEnergyUsageLocationAnalysisIndexRoute:
    DashboardEnergyUsageLocationAnalysisIndexRoute,
  DashboardEnergyUsageMeterAnalysisIndexRoute:
    DashboardEnergyUsageMeterAnalysisIndexRoute,
  DashboardEnergyUsageProductionIndexRoute:
    DashboardEnergyUsageProductionIndexRoute,
  DashboardUsersCreateIndexRoute: DashboardUsersCreateIndexRoute,
  DashboardMySitesCreateIndexLazyRoute: DashboardMySitesCreateIndexLazyRoute,
  DashboardAirQualityMapFloorIdIndexRoute:
    DashboardAirQualityMapFloorIdIndexRoute,
  DashboardUsersEditUserIdIndexRoute: DashboardUsersEditUserIdIndexRoute,
}

const DashboardRouteWithChildren = DashboardRoute._addFileChildren(
  DashboardRouteChildren,
)

export interface FileRoutesByFullPath {
  '': typeof DashboardRouteWithChildren
  '/login': typeof AuthLoginRoute
  '/reset-password': typeof AuthResetPasswordRoute
  '/admin': typeof DashboardAdminRouteWithChildren
  '/403': typeof R403IndexRoute
  '/': typeof AuthIndexRoute
  '/site/$id': typeof DashboardSiteIdRouteWithChildren
  '/admin/': typeof DashboardAdminIndexRoute
  '/energy-monitoring': typeof DashboardEnergyMonitoringIndexRoute
  '/energy-usage': typeof DashboardEnergyUsageIndexRoute
  '/my-actions': typeof DashboardMyActionsIndexRoute
  '/my-sites': typeof DashboardMySitesIndexRoute
  '/tutorials': typeof DashboardTutorialsIndexRoute
  '/users': typeof DashboardUsersIndexRoute
  '/admin/dynamic-heat-curve': typeof DashboardAdminDynamicHeatCurveIndexRoute
  '/admin/heat-curve-default': typeof DashboardAdminHeatCurveDefaultIndexRoute
  '/admin/sidebar-sections': typeof DashboardAdminSidebarSectionsIndexRoute
  '/admin/synoptics': typeof DashboardAdminSynopticsIndexRoute
  '/air-quality/conformity': typeof DashboardAirQualityConformityIndexRoute
  '/air-quality/history': typeof DashboardAirQualityHistoryIndexRoute
  '/air-quality/map': typeof DashboardAirQualityMapIndexRoute
  '/air-quality/settings': typeof DashboardAirQualitySettingsIndexRoute
  '/comfort/temperature': typeof DashboardComfortTemperatureIndexRoute
  '/company/settings': typeof DashboardCompanySettingsIndexRoute
  '/energy-monitoring/air-handling-unit': typeof DashboardEnergyMonitoringAirHandlingUnitIndexRoute
  '/energy-monitoring/heating': typeof DashboardEnergyMonitoringHeatingIndexRoute
  '/energy-usage/dashboard': typeof DashboardEnergyUsageDashboardIndexRoute
  '/energy-usage/evolution': typeof DashboardEnergyUsageEvolutionIndexRoute
  '/energy-usage/location-analysis': typeof DashboardEnergyUsageLocationAnalysisIndexRoute
  '/energy-usage/meter-analysis': typeof DashboardEnergyUsageMeterAnalysisIndexRoute
  '/energy-usage/production': typeof DashboardEnergyUsageProductionIndexRoute
  '/users/create': typeof DashboardUsersCreateIndexRoute
  '/my-sites/create': typeof DashboardMySitesCreateIndexLazyRoute
  '/admin/synoptics/$id': typeof DashboardAdminSynopticsIdIndexRoute
  '/admin/synoptics/create': typeof DashboardAdminSynopticsCreateIndexRoute
  '/air-quality/map/$floorId': typeof DashboardAirQualityMapFloorIdIndexRoute
  '/site/$id/actions-assignation': typeof DashboardSiteIdActionsAssignationIndexRoute
  '/site/$id/actions-done': typeof DashboardSiteIdActionsDoneIndexRoute
  '/site/$id/alarms': typeof DashboardSiteIdAlarmsIndexRoute
  '/site/$id/alerts': typeof DashboardSiteIdAlertsIndexRoute
  '/site/$id/defaults': typeof DashboardSiteIdDefaultsIndexRoute
  '/site/$id/devices': typeof DashboardSiteIdDevicesIndexRoute
  '/site/$id/electrical': typeof DashboardSiteIdElectricalIndexRoute
  '/site/$id/equipment': typeof DashboardSiteIdEquipmentIndexRoute
  '/site/$id/information': typeof DashboardSiteIdInformationIndexRoute
  '/site/$id/lighting': typeof DashboardSiteIdLightingIndexRoute
  '/site/$id/logbook': typeof DashboardSiteIdLogbookIndexRoute
  '/site/$id/medical-fluid': typeof DashboardSiteIdMedicalFluidIndexRoute
  '/site/$id/monitoring': typeof DashboardSiteIdMonitoringIndexRoute
  '/site/$id/my-actions': typeof DashboardSiteIdMyActionsIndexRoute
  '/site/$id/non-conformity': typeof DashboardSiteIdNonConformityIndexRoute
  '/site/$id/reports': typeof DashboardSiteIdReportsIndexRoute
  '/site/$id/sensor-plan': typeof DashboardSiteIdSensorPlanIndexRoute
  '/users/edit/$userId': typeof DashboardUsersEditUserIdIndexRoute
  '/site/$id/equipment/$equipmentId': typeof DashboardSiteIdEquipmentEquipmentIdLayoutRouteWithChildren
  '/site/$id/actions-done/$actionId': typeof DashboardSiteIdActionsDoneActionIdIndexRoute
  '/site/$id/alarms/$equipmentId': typeof DashboardSiteIdAlarmsEquipmentIdIndexRoute
  '/site/$id/alerts/create': typeof DashboardSiteIdAlertsCreateIndexRoute
  '/site/$id/boiler-room/technical': typeof DashboardSiteIdBoilerRoomTechnicalIndexRoute
  '/site/$id/comfort/monitoring': typeof DashboardSiteIdComfortMonitoringIndexRoute
  '/site/$id/dashboard/general': typeof DashboardSiteIdDashboardGeneralIndexRoute
  '/site/$id/dashboard/recommendations': typeof DashboardSiteIdDashboardRecommendationsIndexRoute
  '/site/$id/defaults/$equipmentId': typeof DashboardSiteIdDefaultsEquipmentIdIndexRoute
  '/site/$id/drift/equipment': typeof DashboardSiteIdDriftEquipmentIndexRoute
  '/site/$id/drift/settings': typeof DashboardSiteIdDriftSettingsIndexRoute
  '/site/$id/electrical/$floorId': typeof DashboardSiteIdElectricalFloorIdIndexRoute
  '/site/$id/equipment/choose-sample': typeof DashboardSiteIdEquipmentChooseSampleIndexRoute
  '/site/$id/equipment/create': typeof DashboardSiteIdEquipmentCreateIndexRoute
  '/site/$id/equipment/energy': typeof DashboardSiteIdEquipmentEnergyIndexRoute
  '/site/$id/heat-pump/mode': typeof DashboardSiteIdHeatPumpModeIndexRoute
  '/site/$id/heat-pump/technical': typeof DashboardSiteIdHeatPumpTechnicalIndexRoute
  '/site/$id/information/add-work': typeof DashboardSiteIdInformationAddWorkIndexRoute
  '/site/$id/lighting/$floorId': typeof DashboardSiteIdLightingFloorIdIndexRoute
  '/site/$id/logbook/$workId': typeof DashboardSiteIdLogbookWorkIdIndexRoute
  '/site/$id/logbook/add-log': typeof DashboardSiteIdLogbookAddLogIndexRoute
  '/site/$id/medical-fluid/$floorId': typeof DashboardSiteIdMedicalFluidFloorIdIndexRoute
  '/site/$id/monitoring/$deviceId': typeof DashboardSiteIdMonitoringDeviceIdIndexRoute
  '/site/$id/my-actions/$actionId': typeof DashboardSiteIdMyActionsActionIdIndexRoute
  '/site/$id/non-conformity/$actionId': typeof DashboardSiteIdNonConformityActionIdIndexRoute
  '/site/$id/operation/scheduler': typeof DashboardSiteIdOperationSchedulerIndexRoute
  '/site/$id/sensor-plan/$floorId': typeof DashboardSiteIdSensorPlanFloorIdIndexRoute
  '/site/$id/vmc/technical': typeof DashboardSiteIdVmcTechnicalIndexRoute
  '/site/$id/equipment/$equipmentId/actions': typeof DashboardSiteIdEquipmentEquipmentIdLayoutActionsRoute
  '/site/$id/equipment/$equipmentId/devices': typeof DashboardSiteIdEquipmentEquipmentIdLayoutDevicesRoute
  '/site/$id/equipment/$equipmentId/information': typeof DashboardSiteIdEquipmentEquipmentIdLayoutInformationRoute
  '/site/$id/alerts/edit/$alertId': typeof DashboardSiteIdAlertsEditAlertIdIndexRoute
  '/site/$id/alerts/edit/device-disconnected': typeof DashboardSiteIdAlertsEditDeviceDisconnectedIndexRoute
  '/site/$id/boiler-room/technical/generate': typeof DashboardSiteIdBoilerRoomTechnicalGenerateIndexRoute
  '/site/$id/boiler-room/technical/manage': typeof DashboardSiteIdBoilerRoomTechnicalManageIndexRoute
  '/site/$id/comfort/monitoring/$floorId': typeof DashboardSiteIdComfortMonitoringFloorIdIndexRoute
  '/site/$id/comfort/monitoring/configuration': typeof DashboardSiteIdComfortMonitoringConfigurationIndexRoute
  '/site/$id/devices/edit/$deviceId': typeof DashboardSiteIdDevicesEditDeviceIdIndexRoute
  '/site/$id/equipment/energy/$equipmentId': typeof DashboardSiteIdEquipmentEnergyEquipmentIdIndexRoute
  '/site/$id/heat-pump/technical/generate': typeof DashboardSiteIdHeatPumpTechnicalGenerateIndexRoute
  '/site/$id/heat-pump/technical/manage': typeof DashboardSiteIdHeatPumpTechnicalManageIndexRoute
  '/site/$id/information/work/$workId': typeof DashboardSiteIdInformationWorkWorkIdIndexRoute
  '/site/$id/operation/scheduler/$scheduleId': typeof DashboardSiteIdOperationSchedulerScheduleIdIndexRoute
  '/site/$id/operation/scheduler/create': typeof DashboardSiteIdOperationSchedulerCreateIndexRoute
  '/site/$id/reports/configuration/create': typeof DashboardSiteIdReportsConfigurationCreateIndexRoute
  '/site/$id/vmc/technical/manage': typeof DashboardSiteIdVmcTechnicalManageIndexRoute
  '/site/$id/alerts/edit/$alertId/comment': typeof DashboardSiteIdAlertsEditAlertIdCommentIndexRoute
  '/site/$id/boiler-room/technical/manage/$synopticId': typeof DashboardSiteIdBoilerRoomTechnicalManageSynopticIdIndexRoute
  '/site/$id/heat-pump/technical/manage/$synopticId': typeof DashboardSiteIdHeatPumpTechnicalManageSynopticIdIndexRoute
  '/site/$id/operation/scheduler/cta/$zoneCtaId': typeof DashboardSiteIdOperationSchedulerCtaZoneCtaIdIndexRoute
  '/site/$id/reports/configuration/edit/$reportId': typeof DashboardSiteIdReportsConfigurationEditReportIdIndexRoute
}

export interface FileRoutesByTo {
  '': typeof DashboardRouteWithChildren
  '/login': typeof AuthLoginRoute
  '/reset-password': typeof AuthResetPasswordRoute
  '/403': typeof R403IndexRoute
  '/': typeof AuthIndexRoute
  '/site/$id': typeof DashboardSiteIdRouteWithChildren
  '/admin': typeof DashboardAdminIndexRoute
  '/energy-monitoring': typeof DashboardEnergyMonitoringIndexRoute
  '/energy-usage': typeof DashboardEnergyUsageIndexRoute
  '/my-actions': typeof DashboardMyActionsIndexRoute
  '/my-sites': typeof DashboardMySitesIndexRoute
  '/tutorials': typeof DashboardTutorialsIndexRoute
  '/users': typeof DashboardUsersIndexRoute
  '/admin/dynamic-heat-curve': typeof DashboardAdminDynamicHeatCurveIndexRoute
  '/admin/heat-curve-default': typeof DashboardAdminHeatCurveDefaultIndexRoute
  '/admin/sidebar-sections': typeof DashboardAdminSidebarSectionsIndexRoute
  '/admin/synoptics': typeof DashboardAdminSynopticsIndexRoute
  '/air-quality/conformity': typeof DashboardAirQualityConformityIndexRoute
  '/air-quality/history': typeof DashboardAirQualityHistoryIndexRoute
  '/air-quality/map': typeof DashboardAirQualityMapIndexRoute
  '/air-quality/settings': typeof DashboardAirQualitySettingsIndexRoute
  '/comfort/temperature': typeof DashboardComfortTemperatureIndexRoute
  '/company/settings': typeof DashboardCompanySettingsIndexRoute
  '/energy-monitoring/air-handling-unit': typeof DashboardEnergyMonitoringAirHandlingUnitIndexRoute
  '/energy-monitoring/heating': typeof DashboardEnergyMonitoringHeatingIndexRoute
  '/energy-usage/dashboard': typeof DashboardEnergyUsageDashboardIndexRoute
  '/energy-usage/evolution': typeof DashboardEnergyUsageEvolutionIndexRoute
  '/energy-usage/location-analysis': typeof DashboardEnergyUsageLocationAnalysisIndexRoute
  '/energy-usage/meter-analysis': typeof DashboardEnergyUsageMeterAnalysisIndexRoute
  '/energy-usage/production': typeof DashboardEnergyUsageProductionIndexRoute
  '/users/create': typeof DashboardUsersCreateIndexRoute
  '/my-sites/create': typeof DashboardMySitesCreateIndexLazyRoute
  '/admin/synoptics/$id': typeof DashboardAdminSynopticsIdIndexRoute
  '/admin/synoptics/create': typeof DashboardAdminSynopticsCreateIndexRoute
  '/air-quality/map/$floorId': typeof DashboardAirQualityMapFloorIdIndexRoute
  '/site/$id/actions-assignation': typeof DashboardSiteIdActionsAssignationIndexRoute
  '/site/$id/actions-done': typeof DashboardSiteIdActionsDoneIndexRoute
  '/site/$id/alarms': typeof DashboardSiteIdAlarmsIndexRoute
  '/site/$id/alerts': typeof DashboardSiteIdAlertsIndexRoute
  '/site/$id/defaults': typeof DashboardSiteIdDefaultsIndexRoute
  '/site/$id/devices': typeof DashboardSiteIdDevicesIndexRoute
  '/site/$id/electrical': typeof DashboardSiteIdElectricalIndexRoute
  '/site/$id/equipment': typeof DashboardSiteIdEquipmentIndexRoute
  '/site/$id/information': typeof DashboardSiteIdInformationIndexRoute
  '/site/$id/lighting': typeof DashboardSiteIdLightingIndexRoute
  '/site/$id/logbook': typeof DashboardSiteIdLogbookIndexRoute
  '/site/$id/medical-fluid': typeof DashboardSiteIdMedicalFluidIndexRoute
  '/site/$id/monitoring': typeof DashboardSiteIdMonitoringIndexRoute
  '/site/$id/my-actions': typeof DashboardSiteIdMyActionsIndexRoute
  '/site/$id/non-conformity': typeof DashboardSiteIdNonConformityIndexRoute
  '/site/$id/reports': typeof DashboardSiteIdReportsIndexRoute
  '/site/$id/sensor-plan': typeof DashboardSiteIdSensorPlanIndexRoute
  '/users/edit/$userId': typeof DashboardUsersEditUserIdIndexRoute
  '/site/$id/equipment/$equipmentId': typeof DashboardSiteIdEquipmentEquipmentIdLayoutRouteWithChildren
  '/site/$id/actions-done/$actionId': typeof DashboardSiteIdActionsDoneActionIdIndexRoute
  '/site/$id/alarms/$equipmentId': typeof DashboardSiteIdAlarmsEquipmentIdIndexRoute
  '/site/$id/alerts/create': typeof DashboardSiteIdAlertsCreateIndexRoute
  '/site/$id/boiler-room/technical': typeof DashboardSiteIdBoilerRoomTechnicalIndexRoute
  '/site/$id/comfort/monitoring': typeof DashboardSiteIdComfortMonitoringIndexRoute
  '/site/$id/dashboard/general': typeof DashboardSiteIdDashboardGeneralIndexRoute
  '/site/$id/dashboard/recommendations': typeof DashboardSiteIdDashboardRecommendationsIndexRoute
  '/site/$id/defaults/$equipmentId': typeof DashboardSiteIdDefaultsEquipmentIdIndexRoute
  '/site/$id/drift/equipment': typeof DashboardSiteIdDriftEquipmentIndexRoute
  '/site/$id/drift/settings': typeof DashboardSiteIdDriftSettingsIndexRoute
  '/site/$id/electrical/$floorId': typeof DashboardSiteIdElectricalFloorIdIndexRoute
  '/site/$id/equipment/choose-sample': typeof DashboardSiteIdEquipmentChooseSampleIndexRoute
  '/site/$id/equipment/create': typeof DashboardSiteIdEquipmentCreateIndexRoute
  '/site/$id/equipment/energy': typeof DashboardSiteIdEquipmentEnergyIndexRoute
  '/site/$id/heat-pump/mode': typeof DashboardSiteIdHeatPumpModeIndexRoute
  '/site/$id/heat-pump/technical': typeof DashboardSiteIdHeatPumpTechnicalIndexRoute
  '/site/$id/information/add-work': typeof DashboardSiteIdInformationAddWorkIndexRoute
  '/site/$id/lighting/$floorId': typeof DashboardSiteIdLightingFloorIdIndexRoute
  '/site/$id/logbook/$workId': typeof DashboardSiteIdLogbookWorkIdIndexRoute
  '/site/$id/logbook/add-log': typeof DashboardSiteIdLogbookAddLogIndexRoute
  '/site/$id/medical-fluid/$floorId': typeof DashboardSiteIdMedicalFluidFloorIdIndexRoute
  '/site/$id/monitoring/$deviceId': typeof DashboardSiteIdMonitoringDeviceIdIndexRoute
  '/site/$id/my-actions/$actionId': typeof DashboardSiteIdMyActionsActionIdIndexRoute
  '/site/$id/non-conformity/$actionId': typeof DashboardSiteIdNonConformityActionIdIndexRoute
  '/site/$id/operation/scheduler': typeof DashboardSiteIdOperationSchedulerIndexRoute
  '/site/$id/sensor-plan/$floorId': typeof DashboardSiteIdSensorPlanFloorIdIndexRoute
  '/site/$id/vmc/technical': typeof DashboardSiteIdVmcTechnicalIndexRoute
  '/site/$id/equipment/$equipmentId/actions': typeof DashboardSiteIdEquipmentEquipmentIdLayoutActionsRoute
  '/site/$id/equipment/$equipmentId/devices': typeof DashboardSiteIdEquipmentEquipmentIdLayoutDevicesRoute
  '/site/$id/equipment/$equipmentId/information': typeof DashboardSiteIdEquipmentEquipmentIdLayoutInformationRoute
  '/site/$id/alerts/edit/$alertId': typeof DashboardSiteIdAlertsEditAlertIdIndexRoute
  '/site/$id/alerts/edit/device-disconnected': typeof DashboardSiteIdAlertsEditDeviceDisconnectedIndexRoute
  '/site/$id/boiler-room/technical/generate': typeof DashboardSiteIdBoilerRoomTechnicalGenerateIndexRoute
  '/site/$id/boiler-room/technical/manage': typeof DashboardSiteIdBoilerRoomTechnicalManageIndexRoute
  '/site/$id/comfort/monitoring/$floorId': typeof DashboardSiteIdComfortMonitoringFloorIdIndexRoute
  '/site/$id/comfort/monitoring/configuration': typeof DashboardSiteIdComfortMonitoringConfigurationIndexRoute
  '/site/$id/devices/edit/$deviceId': typeof DashboardSiteIdDevicesEditDeviceIdIndexRoute
  '/site/$id/equipment/energy/$equipmentId': typeof DashboardSiteIdEquipmentEnergyEquipmentIdIndexRoute
  '/site/$id/heat-pump/technical/generate': typeof DashboardSiteIdHeatPumpTechnicalGenerateIndexRoute
  '/site/$id/heat-pump/technical/manage': typeof DashboardSiteIdHeatPumpTechnicalManageIndexRoute
  '/site/$id/information/work/$workId': typeof DashboardSiteIdInformationWorkWorkIdIndexRoute
  '/site/$id/operation/scheduler/$scheduleId': typeof DashboardSiteIdOperationSchedulerScheduleIdIndexRoute
  '/site/$id/operation/scheduler/create': typeof DashboardSiteIdOperationSchedulerCreateIndexRoute
  '/site/$id/reports/configuration/create': typeof DashboardSiteIdReportsConfigurationCreateIndexRoute
  '/site/$id/vmc/technical/manage': typeof DashboardSiteIdVmcTechnicalManageIndexRoute
  '/site/$id/alerts/edit/$alertId/comment': typeof DashboardSiteIdAlertsEditAlertIdCommentIndexRoute
  '/site/$id/boiler-room/technical/manage/$synopticId': typeof DashboardSiteIdBoilerRoomTechnicalManageSynopticIdIndexRoute
  '/site/$id/heat-pump/technical/manage/$synopticId': typeof DashboardSiteIdHeatPumpTechnicalManageSynopticIdIndexRoute
  '/site/$id/operation/scheduler/cta/$zoneCtaId': typeof DashboardSiteIdOperationSchedulerCtaZoneCtaIdIndexRoute
  '/site/$id/reports/configuration/edit/$reportId': typeof DashboardSiteIdReportsConfigurationEditReportIdIndexRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/_auth': typeof AuthRouteWithChildren
  '/_dashboard': typeof DashboardRouteWithChildren
  '/_auth/login': typeof AuthLoginRoute
  '/_auth/reset-password': typeof AuthResetPasswordRoute
  '/_dashboard/admin': typeof DashboardAdminRouteWithChildren
  '/403/': typeof R403IndexRoute
  '/_auth/': typeof AuthIndexRoute
  '/_dashboard/site/$id': typeof DashboardSiteIdRouteWithChildren
  '/_dashboard/admin/': typeof DashboardAdminIndexRoute
  '/_dashboard/energy-monitoring/': typeof DashboardEnergyMonitoringIndexRoute
  '/_dashboard/energy-usage/': typeof DashboardEnergyUsageIndexRoute
  '/_dashboard/my-actions/': typeof DashboardMyActionsIndexRoute
  '/_dashboard/my-sites/': typeof DashboardMySitesIndexRoute
  '/_dashboard/tutorials/': typeof DashboardTutorialsIndexRoute
  '/_dashboard/users/': typeof DashboardUsersIndexRoute
  '/_dashboard/admin/dynamic-heat-curve/': typeof DashboardAdminDynamicHeatCurveIndexRoute
  '/_dashboard/admin/heat-curve-default/': typeof DashboardAdminHeatCurveDefaultIndexRoute
  '/_dashboard/admin/sidebar-sections/': typeof DashboardAdminSidebarSectionsIndexRoute
  '/_dashboard/admin/synoptics/': typeof DashboardAdminSynopticsIndexRoute
  '/_dashboard/air-quality/conformity/': typeof DashboardAirQualityConformityIndexRoute
  '/_dashboard/air-quality/history/': typeof DashboardAirQualityHistoryIndexRoute
  '/_dashboard/air-quality/map/': typeof DashboardAirQualityMapIndexRoute
  '/_dashboard/air-quality/settings/': typeof DashboardAirQualitySettingsIndexRoute
  '/_dashboard/comfort/temperature/': typeof DashboardComfortTemperatureIndexRoute
  '/_dashboard/company/settings/': typeof DashboardCompanySettingsIndexRoute
  '/_dashboard/energy-monitoring/air-handling-unit/': typeof DashboardEnergyMonitoringAirHandlingUnitIndexRoute
  '/_dashboard/energy-monitoring/heating/': typeof DashboardEnergyMonitoringHeatingIndexRoute
  '/_dashboard/energy-usage/dashboard/': typeof DashboardEnergyUsageDashboardIndexRoute
  '/_dashboard/energy-usage/evolution/': typeof DashboardEnergyUsageEvolutionIndexRoute
  '/_dashboard/energy-usage/location-analysis/': typeof DashboardEnergyUsageLocationAnalysisIndexRoute
  '/_dashboard/energy-usage/meter-analysis/': typeof DashboardEnergyUsageMeterAnalysisIndexRoute
  '/_dashboard/energy-usage/production/': typeof DashboardEnergyUsageProductionIndexRoute
  '/_dashboard/users/create/': typeof DashboardUsersCreateIndexRoute
  '/_dashboard/my-sites/create/': typeof DashboardMySitesCreateIndexLazyRoute
  '/_dashboard/admin/synoptics/$id/': typeof DashboardAdminSynopticsIdIndexRoute
  '/_dashboard/admin/synoptics/create/': typeof DashboardAdminSynopticsCreateIndexRoute
  '/_dashboard/air-quality/map/$floorId/': typeof DashboardAirQualityMapFloorIdIndexRoute
  '/_dashboard/site/$id/actions-assignation/': typeof DashboardSiteIdActionsAssignationIndexRoute
  '/_dashboard/site/$id/actions-done/': typeof DashboardSiteIdActionsDoneIndexRoute
  '/_dashboard/site/$id/alarms/': typeof DashboardSiteIdAlarmsIndexRoute
  '/_dashboard/site/$id/alerts/': typeof DashboardSiteIdAlertsIndexRoute
  '/_dashboard/site/$id/defaults/': typeof DashboardSiteIdDefaultsIndexRoute
  '/_dashboard/site/$id/devices/': typeof DashboardSiteIdDevicesIndexRoute
  '/_dashboard/site/$id/electrical/': typeof DashboardSiteIdElectricalIndexRoute
  '/_dashboard/site/$id/equipment/': typeof DashboardSiteIdEquipmentIndexRoute
  '/_dashboard/site/$id/information/': typeof DashboardSiteIdInformationIndexRoute
  '/_dashboard/site/$id/lighting/': typeof DashboardSiteIdLightingIndexRoute
  '/_dashboard/site/$id/logbook/': typeof DashboardSiteIdLogbookIndexRoute
  '/_dashboard/site/$id/medical-fluid/': typeof DashboardSiteIdMedicalFluidIndexRoute
  '/_dashboard/site/$id/monitoring/': typeof DashboardSiteIdMonitoringIndexRoute
  '/_dashboard/site/$id/my-actions/': typeof DashboardSiteIdMyActionsIndexRoute
  '/_dashboard/site/$id/non-conformity/': typeof DashboardSiteIdNonConformityIndexRoute
  '/_dashboard/site/$id/reports/': typeof DashboardSiteIdReportsIndexRoute
  '/_dashboard/site/$id/sensor-plan/': typeof DashboardSiteIdSensorPlanIndexRoute
  '/_dashboard/users/edit/$userId/': typeof DashboardUsersEditUserIdIndexRoute
  '/_dashboard/site/$id/equipment/$equipmentId': typeof DashboardSiteIdEquipmentEquipmentIdRouteWithChildren
  '/_dashboard/site/$id/equipment/$equipmentId/_layout': typeof DashboardSiteIdEquipmentEquipmentIdLayoutRouteWithChildren
  '/_dashboard/site/$id/actions-done/$actionId/': typeof DashboardSiteIdActionsDoneActionIdIndexRoute
  '/_dashboard/site/$id/alarms/$equipmentId/': typeof DashboardSiteIdAlarmsEquipmentIdIndexRoute
  '/_dashboard/site/$id/alerts/create/': typeof DashboardSiteIdAlertsCreateIndexRoute
  '/_dashboard/site/$id/boiler-room/technical/': typeof DashboardSiteIdBoilerRoomTechnicalIndexRoute
  '/_dashboard/site/$id/comfort/monitoring/': typeof DashboardSiteIdComfortMonitoringIndexRoute
  '/_dashboard/site/$id/dashboard/general/': typeof DashboardSiteIdDashboardGeneralIndexRoute
  '/_dashboard/site/$id/dashboard/recommendations/': typeof DashboardSiteIdDashboardRecommendationsIndexRoute
  '/_dashboard/site/$id/defaults/$equipmentId/': typeof DashboardSiteIdDefaultsEquipmentIdIndexRoute
  '/_dashboard/site/$id/drift/equipment/': typeof DashboardSiteIdDriftEquipmentIndexRoute
  '/_dashboard/site/$id/drift/settings/': typeof DashboardSiteIdDriftSettingsIndexRoute
  '/_dashboard/site/$id/electrical/$floorId/': typeof DashboardSiteIdElectricalFloorIdIndexRoute
  '/_dashboard/site/$id/equipment/choose-sample/': typeof DashboardSiteIdEquipmentChooseSampleIndexRoute
  '/_dashboard/site/$id/equipment/create/': typeof DashboardSiteIdEquipmentCreateIndexRoute
  '/_dashboard/site/$id/equipment/energy/': typeof DashboardSiteIdEquipmentEnergyIndexRoute
  '/_dashboard/site/$id/heat-pump/mode/': typeof DashboardSiteIdHeatPumpModeIndexRoute
  '/_dashboard/site/$id/heat-pump/technical/': typeof DashboardSiteIdHeatPumpTechnicalIndexRoute
  '/_dashboard/site/$id/information/add-work/': typeof DashboardSiteIdInformationAddWorkIndexRoute
  '/_dashboard/site/$id/lighting/$floorId/': typeof DashboardSiteIdLightingFloorIdIndexRoute
  '/_dashboard/site/$id/logbook/$workId/': typeof DashboardSiteIdLogbookWorkIdIndexRoute
  '/_dashboard/site/$id/logbook/add-log/': typeof DashboardSiteIdLogbookAddLogIndexRoute
  '/_dashboard/site/$id/medical-fluid/$floorId/': typeof DashboardSiteIdMedicalFluidFloorIdIndexRoute
  '/_dashboard/site/$id/monitoring/$deviceId/': typeof DashboardSiteIdMonitoringDeviceIdIndexRoute
  '/_dashboard/site/$id/my-actions/$actionId/': typeof DashboardSiteIdMyActionsActionIdIndexRoute
  '/_dashboard/site/$id/non-conformity/$actionId/': typeof DashboardSiteIdNonConformityActionIdIndexRoute
  '/_dashboard/site/$id/operation/scheduler/': typeof DashboardSiteIdOperationSchedulerIndexRoute
  '/_dashboard/site/$id/sensor-plan/$floorId/': typeof DashboardSiteIdSensorPlanFloorIdIndexRoute
  '/_dashboard/site/$id/vmc/technical/': typeof DashboardSiteIdVmcTechnicalIndexRoute
  '/_dashboard/site/$id/equipment/$equipmentId/_layout/actions': typeof DashboardSiteIdEquipmentEquipmentIdLayoutActionsRoute
  '/_dashboard/site/$id/equipment/$equipmentId/_layout/devices': typeof DashboardSiteIdEquipmentEquipmentIdLayoutDevicesRoute
  '/_dashboard/site/$id/equipment/$equipmentId/_layout/information': typeof DashboardSiteIdEquipmentEquipmentIdLayoutInformationRoute
  '/_dashboard/site/$id/alerts/edit/$alertId/': typeof DashboardSiteIdAlertsEditAlertIdIndexRoute
  '/_dashboard/site/$id/alerts/edit/device-disconnected/': typeof DashboardSiteIdAlertsEditDeviceDisconnectedIndexRoute
  '/_dashboard/site/$id/boiler-room/technical/generate/': typeof DashboardSiteIdBoilerRoomTechnicalGenerateIndexRoute
  '/_dashboard/site/$id/boiler-room/technical/manage/': typeof DashboardSiteIdBoilerRoomTechnicalManageIndexRoute
  '/_dashboard/site/$id/comfort/monitoring/$floorId/': typeof DashboardSiteIdComfortMonitoringFloorIdIndexRoute
  '/_dashboard/site/$id/comfort/monitoring/configuration/': typeof DashboardSiteIdComfortMonitoringConfigurationIndexRoute
  '/_dashboard/site/$id/devices/edit/$deviceId/': typeof DashboardSiteIdDevicesEditDeviceIdIndexRoute
  '/_dashboard/site/$id/equipment/energy/$equipmentId/': typeof DashboardSiteIdEquipmentEnergyEquipmentIdIndexRoute
  '/_dashboard/site/$id/heat-pump/technical/generate/': typeof DashboardSiteIdHeatPumpTechnicalGenerateIndexRoute
  '/_dashboard/site/$id/heat-pump/technical/manage/': typeof DashboardSiteIdHeatPumpTechnicalManageIndexRoute
  '/_dashboard/site/$id/information/work/$workId/': typeof DashboardSiteIdInformationWorkWorkIdIndexRoute
  '/_dashboard/site/$id/operation/scheduler/$scheduleId/': typeof DashboardSiteIdOperationSchedulerScheduleIdIndexRoute
  '/_dashboard/site/$id/operation/scheduler/create/': typeof DashboardSiteIdOperationSchedulerCreateIndexRoute
  '/_dashboard/site/$id/reports/configuration/create/': typeof DashboardSiteIdReportsConfigurationCreateIndexRoute
  '/_dashboard/site/$id/vmc/technical/manage/': typeof DashboardSiteIdVmcTechnicalManageIndexRoute
  '/_dashboard/site/$id/alerts/edit/$alertId/comment/': typeof DashboardSiteIdAlertsEditAlertIdCommentIndexRoute
  '/_dashboard/site/$id/boiler-room/technical/manage/$synopticId/': typeof DashboardSiteIdBoilerRoomTechnicalManageSynopticIdIndexRoute
  '/_dashboard/site/$id/heat-pump/technical/manage/$synopticId/': typeof DashboardSiteIdHeatPumpTechnicalManageSynopticIdIndexRoute
  '/_dashboard/site/$id/operation/scheduler/cta/$zoneCtaId/': typeof DashboardSiteIdOperationSchedulerCtaZoneCtaIdIndexRoute
  '/_dashboard/site/$id/reports/configuration/edit/$reportId/': typeof DashboardSiteIdReportsConfigurationEditReportIdIndexRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | ''
    | '/login'
    | '/reset-password'
    | '/admin'
    | '/403'
    | '/'
    | '/site/$id'
    | '/admin/'
    | '/energy-monitoring'
    | '/energy-usage'
    | '/my-actions'
    | '/my-sites'
    | '/tutorials'
    | '/users'
    | '/admin/dynamic-heat-curve'
    | '/admin/heat-curve-default'
    | '/admin/sidebar-sections'
    | '/admin/synoptics'
    | '/air-quality/conformity'
    | '/air-quality/history'
    | '/air-quality/map'
    | '/air-quality/settings'
    | '/comfort/temperature'
    | '/company/settings'
    | '/energy-monitoring/air-handling-unit'
    | '/energy-monitoring/heating'
    | '/energy-usage/dashboard'
    | '/energy-usage/evolution'
    | '/energy-usage/location-analysis'
    | '/energy-usage/meter-analysis'
    | '/energy-usage/production'
    | '/users/create'
    | '/my-sites/create'
    | '/admin/synoptics/$id'
    | '/admin/synoptics/create'
    | '/air-quality/map/$floorId'
    | '/site/$id/actions-assignation'
    | '/site/$id/actions-done'
    | '/site/$id/alarms'
    | '/site/$id/alerts'
    | '/site/$id/defaults'
    | '/site/$id/devices'
    | '/site/$id/electrical'
    | '/site/$id/equipment'
    | '/site/$id/information'
    | '/site/$id/lighting'
    | '/site/$id/logbook'
    | '/site/$id/medical-fluid'
    | '/site/$id/monitoring'
    | '/site/$id/my-actions'
    | '/site/$id/non-conformity'
    | '/site/$id/reports'
    | '/site/$id/sensor-plan'
    | '/users/edit/$userId'
    | '/site/$id/equipment/$equipmentId'
    | '/site/$id/actions-done/$actionId'
    | '/site/$id/alarms/$equipmentId'
    | '/site/$id/alerts/create'
    | '/site/$id/boiler-room/technical'
    | '/site/$id/comfort/monitoring'
    | '/site/$id/dashboard/general'
    | '/site/$id/dashboard/recommendations'
    | '/site/$id/defaults/$equipmentId'
    | '/site/$id/drift/equipment'
    | '/site/$id/drift/settings'
    | '/site/$id/electrical/$floorId'
    | '/site/$id/equipment/choose-sample'
    | '/site/$id/equipment/create'
    | '/site/$id/equipment/energy'
    | '/site/$id/heat-pump/mode'
    | '/site/$id/heat-pump/technical'
    | '/site/$id/information/add-work'
    | '/site/$id/lighting/$floorId'
    | '/site/$id/logbook/$workId'
    | '/site/$id/logbook/add-log'
    | '/site/$id/medical-fluid/$floorId'
    | '/site/$id/monitoring/$deviceId'
    | '/site/$id/my-actions/$actionId'
    | '/site/$id/non-conformity/$actionId'
    | '/site/$id/operation/scheduler'
    | '/site/$id/sensor-plan/$floorId'
    | '/site/$id/vmc/technical'
    | '/site/$id/equipment/$equipmentId/actions'
    | '/site/$id/equipment/$equipmentId/devices'
    | '/site/$id/equipment/$equipmentId/information'
    | '/site/$id/alerts/edit/$alertId'
    | '/site/$id/alerts/edit/device-disconnected'
    | '/site/$id/boiler-room/technical/generate'
    | '/site/$id/boiler-room/technical/manage'
    | '/site/$id/comfort/monitoring/$floorId'
    | '/site/$id/comfort/monitoring/configuration'
    | '/site/$id/devices/edit/$deviceId'
    | '/site/$id/equipment/energy/$equipmentId'
    | '/site/$id/heat-pump/technical/generate'
    | '/site/$id/heat-pump/technical/manage'
    | '/site/$id/information/work/$workId'
    | '/site/$id/operation/scheduler/$scheduleId'
    | '/site/$id/operation/scheduler/create'
    | '/site/$id/reports/configuration/create'
    | '/site/$id/vmc/technical/manage'
    | '/site/$id/alerts/edit/$alertId/comment'
    | '/site/$id/boiler-room/technical/manage/$synopticId'
    | '/site/$id/heat-pump/technical/manage/$synopticId'
    | '/site/$id/operation/scheduler/cta/$zoneCtaId'
    | '/site/$id/reports/configuration/edit/$reportId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | ''
    | '/login'
    | '/reset-password'
    | '/403'
    | '/'
    | '/site/$id'
    | '/admin'
    | '/energy-monitoring'
    | '/energy-usage'
    | '/my-actions'
    | '/my-sites'
    | '/tutorials'
    | '/users'
    | '/admin/dynamic-heat-curve'
    | '/admin/heat-curve-default'
    | '/admin/sidebar-sections'
    | '/admin/synoptics'
    | '/air-quality/conformity'
    | '/air-quality/history'
    | '/air-quality/map'
    | '/air-quality/settings'
    | '/comfort/temperature'
    | '/company/settings'
    | '/energy-monitoring/air-handling-unit'
    | '/energy-monitoring/heating'
    | '/energy-usage/dashboard'
    | '/energy-usage/evolution'
    | '/energy-usage/location-analysis'
    | '/energy-usage/meter-analysis'
    | '/energy-usage/production'
    | '/users/create'
    | '/my-sites/create'
    | '/admin/synoptics/$id'
    | '/admin/synoptics/create'
    | '/air-quality/map/$floorId'
    | '/site/$id/actions-assignation'
    | '/site/$id/actions-done'
    | '/site/$id/alarms'
    | '/site/$id/alerts'
    | '/site/$id/defaults'
    | '/site/$id/devices'
    | '/site/$id/electrical'
    | '/site/$id/equipment'
    | '/site/$id/information'
    | '/site/$id/lighting'
    | '/site/$id/logbook'
    | '/site/$id/medical-fluid'
    | '/site/$id/monitoring'
    | '/site/$id/my-actions'
    | '/site/$id/non-conformity'
    | '/site/$id/reports'
    | '/site/$id/sensor-plan'
    | '/users/edit/$userId'
    | '/site/$id/equipment/$equipmentId'
    | '/site/$id/actions-done/$actionId'
    | '/site/$id/alarms/$equipmentId'
    | '/site/$id/alerts/create'
    | '/site/$id/boiler-room/technical'
    | '/site/$id/comfort/monitoring'
    | '/site/$id/dashboard/general'
    | '/site/$id/dashboard/recommendations'
    | '/site/$id/defaults/$equipmentId'
    | '/site/$id/drift/equipment'
    | '/site/$id/drift/settings'
    | '/site/$id/electrical/$floorId'
    | '/site/$id/equipment/choose-sample'
    | '/site/$id/equipment/create'
    | '/site/$id/equipment/energy'
    | '/site/$id/heat-pump/mode'
    | '/site/$id/heat-pump/technical'
    | '/site/$id/information/add-work'
    | '/site/$id/lighting/$floorId'
    | '/site/$id/logbook/$workId'
    | '/site/$id/logbook/add-log'
    | '/site/$id/medical-fluid/$floorId'
    | '/site/$id/monitoring/$deviceId'
    | '/site/$id/my-actions/$actionId'
    | '/site/$id/non-conformity/$actionId'
    | '/site/$id/operation/scheduler'
    | '/site/$id/sensor-plan/$floorId'
    | '/site/$id/vmc/technical'
    | '/site/$id/equipment/$equipmentId/actions'
    | '/site/$id/equipment/$equipmentId/devices'
    | '/site/$id/equipment/$equipmentId/information'
    | '/site/$id/alerts/edit/$alertId'
    | '/site/$id/alerts/edit/device-disconnected'
    | '/site/$id/boiler-room/technical/generate'
    | '/site/$id/boiler-room/technical/manage'
    | '/site/$id/comfort/monitoring/$floorId'
    | '/site/$id/comfort/monitoring/configuration'
    | '/site/$id/devices/edit/$deviceId'
    | '/site/$id/equipment/energy/$equipmentId'
    | '/site/$id/heat-pump/technical/generate'
    | '/site/$id/heat-pump/technical/manage'
    | '/site/$id/information/work/$workId'
    | '/site/$id/operation/scheduler/$scheduleId'
    | '/site/$id/operation/scheduler/create'
    | '/site/$id/reports/configuration/create'
    | '/site/$id/vmc/technical/manage'
    | '/site/$id/alerts/edit/$alertId/comment'
    | '/site/$id/boiler-room/technical/manage/$synopticId'
    | '/site/$id/heat-pump/technical/manage/$synopticId'
    | '/site/$id/operation/scheduler/cta/$zoneCtaId'
    | '/site/$id/reports/configuration/edit/$reportId'
  id:
    | '__root__'
    | '/_auth'
    | '/_dashboard'
    | '/_auth/login'
    | '/_auth/reset-password'
    | '/_dashboard/admin'
    | '/403/'
    | '/_auth/'
    | '/_dashboard/site/$id'
    | '/_dashboard/admin/'
    | '/_dashboard/energy-monitoring/'
    | '/_dashboard/energy-usage/'
    | '/_dashboard/my-actions/'
    | '/_dashboard/my-sites/'
    | '/_dashboard/tutorials/'
    | '/_dashboard/users/'
    | '/_dashboard/admin/dynamic-heat-curve/'
    | '/_dashboard/admin/heat-curve-default/'
    | '/_dashboard/admin/sidebar-sections/'
    | '/_dashboard/admin/synoptics/'
    | '/_dashboard/air-quality/conformity/'
    | '/_dashboard/air-quality/history/'
    | '/_dashboard/air-quality/map/'
    | '/_dashboard/air-quality/settings/'
    | '/_dashboard/comfort/temperature/'
    | '/_dashboard/company/settings/'
    | '/_dashboard/energy-monitoring/air-handling-unit/'
    | '/_dashboard/energy-monitoring/heating/'
    | '/_dashboard/energy-usage/dashboard/'
    | '/_dashboard/energy-usage/evolution/'
    | '/_dashboard/energy-usage/location-analysis/'
    | '/_dashboard/energy-usage/meter-analysis/'
    | '/_dashboard/energy-usage/production/'
    | '/_dashboard/users/create/'
    | '/_dashboard/my-sites/create/'
    | '/_dashboard/admin/synoptics/$id/'
    | '/_dashboard/admin/synoptics/create/'
    | '/_dashboard/air-quality/map/$floorId/'
    | '/_dashboard/site/$id/actions-assignation/'
    | '/_dashboard/site/$id/actions-done/'
    | '/_dashboard/site/$id/alarms/'
    | '/_dashboard/site/$id/alerts/'
    | '/_dashboard/site/$id/defaults/'
    | '/_dashboard/site/$id/devices/'
    | '/_dashboard/site/$id/electrical/'
    | '/_dashboard/site/$id/equipment/'
    | '/_dashboard/site/$id/information/'
    | '/_dashboard/site/$id/lighting/'
    | '/_dashboard/site/$id/logbook/'
    | '/_dashboard/site/$id/medical-fluid/'
    | '/_dashboard/site/$id/monitoring/'
    | '/_dashboard/site/$id/my-actions/'
    | '/_dashboard/site/$id/non-conformity/'
    | '/_dashboard/site/$id/reports/'
    | '/_dashboard/site/$id/sensor-plan/'
    | '/_dashboard/users/edit/$userId/'
    | '/_dashboard/site/$id/equipment/$equipmentId'
    | '/_dashboard/site/$id/equipment/$equipmentId/_layout'
    | '/_dashboard/site/$id/actions-done/$actionId/'
    | '/_dashboard/site/$id/alarms/$equipmentId/'
    | '/_dashboard/site/$id/alerts/create/'
    | '/_dashboard/site/$id/boiler-room/technical/'
    | '/_dashboard/site/$id/comfort/monitoring/'
    | '/_dashboard/site/$id/dashboard/general/'
    | '/_dashboard/site/$id/dashboard/recommendations/'
    | '/_dashboard/site/$id/defaults/$equipmentId/'
    | '/_dashboard/site/$id/drift/equipment/'
    | '/_dashboard/site/$id/drift/settings/'
    | '/_dashboard/site/$id/electrical/$floorId/'
    | '/_dashboard/site/$id/equipment/choose-sample/'
    | '/_dashboard/site/$id/equipment/create/'
    | '/_dashboard/site/$id/equipment/energy/'
    | '/_dashboard/site/$id/heat-pump/mode/'
    | '/_dashboard/site/$id/heat-pump/technical/'
    | '/_dashboard/site/$id/information/add-work/'
    | '/_dashboard/site/$id/lighting/$floorId/'
    | '/_dashboard/site/$id/logbook/$workId/'
    | '/_dashboard/site/$id/logbook/add-log/'
    | '/_dashboard/site/$id/medical-fluid/$floorId/'
    | '/_dashboard/site/$id/monitoring/$deviceId/'
    | '/_dashboard/site/$id/my-actions/$actionId/'
    | '/_dashboard/site/$id/non-conformity/$actionId/'
    | '/_dashboard/site/$id/operation/scheduler/'
    | '/_dashboard/site/$id/sensor-plan/$floorId/'
    | '/_dashboard/site/$id/vmc/technical/'
    | '/_dashboard/site/$id/equipment/$equipmentId/_layout/actions'
    | '/_dashboard/site/$id/equipment/$equipmentId/_layout/devices'
    | '/_dashboard/site/$id/equipment/$equipmentId/_layout/information'
    | '/_dashboard/site/$id/alerts/edit/$alertId/'
    | '/_dashboard/site/$id/alerts/edit/device-disconnected/'
    | '/_dashboard/site/$id/boiler-room/technical/generate/'
    | '/_dashboard/site/$id/boiler-room/technical/manage/'
    | '/_dashboard/site/$id/comfort/monitoring/$floorId/'
    | '/_dashboard/site/$id/comfort/monitoring/configuration/'
    | '/_dashboard/site/$id/devices/edit/$deviceId/'
    | '/_dashboard/site/$id/equipment/energy/$equipmentId/'
    | '/_dashboard/site/$id/heat-pump/technical/generate/'
    | '/_dashboard/site/$id/heat-pump/technical/manage/'
    | '/_dashboard/site/$id/information/work/$workId/'
    | '/_dashboard/site/$id/operation/scheduler/$scheduleId/'
    | '/_dashboard/site/$id/operation/scheduler/create/'
    | '/_dashboard/site/$id/reports/configuration/create/'
    | '/_dashboard/site/$id/vmc/technical/manage/'
    | '/_dashboard/site/$id/alerts/edit/$alertId/comment/'
    | '/_dashboard/site/$id/boiler-room/technical/manage/$synopticId/'
    | '/_dashboard/site/$id/heat-pump/technical/manage/$synopticId/'
    | '/_dashboard/site/$id/operation/scheduler/cta/$zoneCtaId/'
    | '/_dashboard/site/$id/reports/configuration/edit/$reportId/'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  AuthRoute: typeof AuthRouteWithChildren
  DashboardRoute: typeof DashboardRouteWithChildren
  R403IndexRoute: typeof R403IndexRoute
}

const rootRouteChildren: RootRouteChildren = {
  AuthRoute: AuthRouteWithChildren,
  DashboardRoute: DashboardRouteWithChildren,
  R403IndexRoute: R403IndexRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/_auth",
        "/_dashboard",
        "/403/"
      ]
    },
    "/_auth": {
      "filePath": "_auth.tsx",
      "children": [
        "/_auth/login",
        "/_auth/reset-password",
        "/_auth/"
      ]
    },
    "/_dashboard": {
      "filePath": "_dashboard.tsx",
      "children": [
        "/_dashboard/admin",
        "/_dashboard/site/$id",
        "/_dashboard/energy-monitoring/",
        "/_dashboard/energy-usage/",
        "/_dashboard/my-actions/",
        "/_dashboard/my-sites/",
        "/_dashboard/tutorials/",
        "/_dashboard/users/",
        "/_dashboard/air-quality/conformity/",
        "/_dashboard/air-quality/history/",
        "/_dashboard/air-quality/map/",
        "/_dashboard/air-quality/settings/",
        "/_dashboard/comfort/temperature/",
        "/_dashboard/company/settings/",
        "/_dashboard/energy-monitoring/air-handling-unit/",
        "/_dashboard/energy-monitoring/heating/",
        "/_dashboard/energy-usage/dashboard/",
        "/_dashboard/energy-usage/evolution/",
        "/_dashboard/energy-usage/location-analysis/",
        "/_dashboard/energy-usage/meter-analysis/",
        "/_dashboard/energy-usage/production/",
        "/_dashboard/users/create/",
        "/_dashboard/my-sites/create/",
        "/_dashboard/air-quality/map/$floorId/",
        "/_dashboard/users/edit/$userId/"
      ]
    },
    "/_auth/login": {
      "filePath": "_auth.login.tsx",
      "parent": "/_auth"
    },
    "/_auth/reset-password": {
      "filePath": "_auth.reset-password.tsx",
      "parent": "/_auth"
    },
    "/_dashboard/admin": {
      "filePath": "_dashboard.admin.tsx",
      "parent": "/_dashboard",
      "children": [
        "/_dashboard/admin/",
        "/_dashboard/admin/dynamic-heat-curve/",
        "/_dashboard/admin/heat-curve-default/",
        "/_dashboard/admin/sidebar-sections/",
        "/_dashboard/admin/synoptics/",
        "/_dashboard/admin/synoptics/$id/",
        "/_dashboard/admin/synoptics/create/"
      ]
    },
    "/403/": {
      "filePath": "403.index.tsx"
    },
    "/_auth/": {
      "filePath": "_auth.index.tsx",
      "parent": "/_auth"
    },
    "/_dashboard/site/$id": {
      "filePath": "_dashboard.site.$id.tsx",
      "parent": "/_dashboard",
      "children": [
        "/_dashboard/site/$id/actions-assignation/",
        "/_dashboard/site/$id/actions-done/",
        "/_dashboard/site/$id/alarms/",
        "/_dashboard/site/$id/alerts/",
        "/_dashboard/site/$id/defaults/",
        "/_dashboard/site/$id/devices/",
        "/_dashboard/site/$id/electrical/",
        "/_dashboard/site/$id/equipment/",
        "/_dashboard/site/$id/information/",
        "/_dashboard/site/$id/lighting/",
        "/_dashboard/site/$id/logbook/",
        "/_dashboard/site/$id/medical-fluid/",
        "/_dashboard/site/$id/monitoring/",
        "/_dashboard/site/$id/my-actions/",
        "/_dashboard/site/$id/non-conformity/",
        "/_dashboard/site/$id/reports/",
        "/_dashboard/site/$id/sensor-plan/",
        "/_dashboard/site/$id/equipment/$equipmentId",
        "/_dashboard/site/$id/actions-done/$actionId/",
        "/_dashboard/site/$id/alarms/$equipmentId/",
        "/_dashboard/site/$id/alerts/create/",
        "/_dashboard/site/$id/boiler-room/technical/",
        "/_dashboard/site/$id/comfort/monitoring/",
        "/_dashboard/site/$id/dashboard/general/",
        "/_dashboard/site/$id/dashboard/recommendations/",
        "/_dashboard/site/$id/defaults/$equipmentId/",
        "/_dashboard/site/$id/drift/equipment/",
        "/_dashboard/site/$id/drift/settings/",
        "/_dashboard/site/$id/electrical/$floorId/",
        "/_dashboard/site/$id/equipment/choose-sample/",
        "/_dashboard/site/$id/equipment/create/",
        "/_dashboard/site/$id/equipment/energy/",
        "/_dashboard/site/$id/heat-pump/mode/",
        "/_dashboard/site/$id/heat-pump/technical/",
        "/_dashboard/site/$id/information/add-work/",
        "/_dashboard/site/$id/lighting/$floorId/",
        "/_dashboard/site/$id/logbook/$workId/",
        "/_dashboard/site/$id/logbook/add-log/",
        "/_dashboard/site/$id/medical-fluid/$floorId/",
        "/_dashboard/site/$id/monitoring/$deviceId/",
        "/_dashboard/site/$id/my-actions/$actionId/",
        "/_dashboard/site/$id/non-conformity/$actionId/",
        "/_dashboard/site/$id/operation/scheduler/",
        "/_dashboard/site/$id/sensor-plan/$floorId/",
        "/_dashboard/site/$id/vmc/technical/",
        "/_dashboard/site/$id/alerts/edit/$alertId/",
        "/_dashboard/site/$id/alerts/edit/device-disconnected/",
        "/_dashboard/site/$id/boiler-room/technical/generate/",
        "/_dashboard/site/$id/boiler-room/technical/manage/",
        "/_dashboard/site/$id/comfort/monitoring/$floorId/",
        "/_dashboard/site/$id/comfort/monitoring/configuration/",
        "/_dashboard/site/$id/devices/edit/$deviceId/",
        "/_dashboard/site/$id/equipment/energy/$equipmentId/",
        "/_dashboard/site/$id/heat-pump/technical/generate/",
        "/_dashboard/site/$id/heat-pump/technical/manage/",
        "/_dashboard/site/$id/information/work/$workId/",
        "/_dashboard/site/$id/operation/scheduler/$scheduleId/",
        "/_dashboard/site/$id/operation/scheduler/create/",
        "/_dashboard/site/$id/reports/configuration/create/",
        "/_dashboard/site/$id/vmc/technical/manage/",
        "/_dashboard/site/$id/alerts/edit/$alertId/comment/",
        "/_dashboard/site/$id/boiler-room/technical/manage/$synopticId/",
        "/_dashboard/site/$id/heat-pump/technical/manage/$synopticId/",
        "/_dashboard/site/$id/operation/scheduler/cta/$zoneCtaId/",
        "/_dashboard/site/$id/reports/configuration/edit/$reportId/"
      ]
    },
    "/_dashboard/admin/": {
      "filePath": "_dashboard/admin/index.tsx",
      "parent": "/_dashboard/admin"
    },
    "/_dashboard/energy-monitoring/": {
      "filePath": "_dashboard/energy-monitoring/index.tsx",
      "parent": "/_dashboard"
    },
    "/_dashboard/energy-usage/": {
      "filePath": "_dashboard/energy-usage/index.tsx",
      "parent": "/_dashboard"
    },
    "/_dashboard/my-actions/": {
      "filePath": "_dashboard/my-actions/index.tsx",
      "parent": "/_dashboard"
    },
    "/_dashboard/my-sites/": {
      "filePath": "_dashboard/my-sites/index.tsx",
      "parent": "/_dashboard"
    },
    "/_dashboard/tutorials/": {
      "filePath": "_dashboard/tutorials/index.tsx",
      "parent": "/_dashboard"
    },
    "/_dashboard/users/": {
      "filePath": "_dashboard/users/index.tsx",
      "parent": "/_dashboard"
    },
    "/_dashboard/admin/dynamic-heat-curve/": {
      "filePath": "_dashboard/admin/dynamic-heat-curve/index.tsx",
      "parent": "/_dashboard/admin"
    },
    "/_dashboard/admin/heat-curve-default/": {
      "filePath": "_dashboard/admin/heat-curve-default/index.tsx",
      "parent": "/_dashboard/admin"
    },
    "/_dashboard/admin/sidebar-sections/": {
      "filePath": "_dashboard/admin/sidebar-sections/index.tsx",
      "parent": "/_dashboard/admin"
    },
    "/_dashboard/admin/synoptics/": {
      "filePath": "_dashboard/admin/synoptics/index.tsx",
      "parent": "/_dashboard/admin"
    },
    "/_dashboard/air-quality/conformity/": {
      "filePath": "_dashboard/air-quality/conformity/index.tsx",
      "parent": "/_dashboard"
    },
    "/_dashboard/air-quality/history/": {
      "filePath": "_dashboard/air-quality/history/index.tsx",
      "parent": "/_dashboard"
    },
    "/_dashboard/air-quality/map/": {
      "filePath": "_dashboard/air-quality/map/index.tsx",
      "parent": "/_dashboard"
    },
    "/_dashboard/air-quality/settings/": {
      "filePath": "_dashboard/air-quality/settings/index.tsx",
      "parent": "/_dashboard"
    },
    "/_dashboard/comfort/temperature/": {
      "filePath": "_dashboard/comfort/temperature/index.tsx",
      "parent": "/_dashboard"
    },
    "/_dashboard/company/settings/": {
      "filePath": "_dashboard/company/settings/index.tsx",
      "parent": "/_dashboard"
    },
    "/_dashboard/energy-monitoring/air-handling-unit/": {
      "filePath": "_dashboard/energy-monitoring/air-handling-unit/index.tsx",
      "parent": "/_dashboard"
    },
    "/_dashboard/energy-monitoring/heating/": {
      "filePath": "_dashboard/energy-monitoring/heating/index.tsx",
      "parent": "/_dashboard"
    },
    "/_dashboard/energy-usage/dashboard/": {
      "filePath": "_dashboard/energy-usage/dashboard/index.tsx",
      "parent": "/_dashboard"
    },
    "/_dashboard/energy-usage/evolution/": {
      "filePath": "_dashboard/energy-usage/evolution/index.tsx",
      "parent": "/_dashboard"
    },
    "/_dashboard/energy-usage/location-analysis/": {
      "filePath": "_dashboard/energy-usage/location-analysis/index.tsx",
      "parent": "/_dashboard"
    },
    "/_dashboard/energy-usage/meter-analysis/": {
      "filePath": "_dashboard/energy-usage/meter-analysis/index.tsx",
      "parent": "/_dashboard"
    },
    "/_dashboard/energy-usage/production/": {
      "filePath": "_dashboard/energy-usage/production/index.tsx",
      "parent": "/_dashboard"
    },
    "/_dashboard/users/create/": {
      "filePath": "_dashboard/users/create/index.tsx",
      "parent": "/_dashboard"
    },
    "/_dashboard/my-sites/create/": {
      "filePath": "_dashboard/my-sites/create/index.lazy.tsx",
      "parent": "/_dashboard"
    },
    "/_dashboard/admin/synoptics/$id/": {
      "filePath": "_dashboard/admin/synoptics/$id/index.tsx",
      "parent": "/_dashboard/admin"
    },
    "/_dashboard/admin/synoptics/create/": {
      "filePath": "_dashboard/admin/synoptics/create/index.tsx",
      "parent": "/_dashboard/admin"
    },
    "/_dashboard/air-quality/map/$floorId/": {
      "filePath": "_dashboard/air-quality/map/$floorId/index.tsx",
      "parent": "/_dashboard"
    },
    "/_dashboard/site/$id/actions-assignation/": {
      "filePath": "_dashboard/site/$id/actions-assignation/index.tsx",
      "parent": "/_dashboard/site/$id"
    },
    "/_dashboard/site/$id/actions-done/": {
      "filePath": "_dashboard/site/$id/actions-done/index.tsx",
      "parent": "/_dashboard/site/$id"
    },
    "/_dashboard/site/$id/alarms/": {
      "filePath": "_dashboard/site/$id/alarms/index.tsx",
      "parent": "/_dashboard/site/$id"
    },
    "/_dashboard/site/$id/alerts/": {
      "filePath": "_dashboard/site/$id/alerts/index.tsx",
      "parent": "/_dashboard/site/$id"
    },
    "/_dashboard/site/$id/defaults/": {
      "filePath": "_dashboard/site/$id/defaults/index.tsx",
      "parent": "/_dashboard/site/$id"
    },
    "/_dashboard/site/$id/devices/": {
      "filePath": "_dashboard/site/$id/devices/index.tsx",
      "parent": "/_dashboard/site/$id"
    },
    "/_dashboard/site/$id/electrical/": {
      "filePath": "_dashboard/site/$id/electrical/index.tsx",
      "parent": "/_dashboard/site/$id"
    },
    "/_dashboard/site/$id/equipment/": {
      "filePath": "_dashboard/site/$id/equipment/index.tsx",
      "parent": "/_dashboard/site/$id"
    },
    "/_dashboard/site/$id/information/": {
      "filePath": "_dashboard/site/$id/information/index.tsx",
      "parent": "/_dashboard/site/$id"
    },
    "/_dashboard/site/$id/lighting/": {
      "filePath": "_dashboard/site/$id/lighting/index.tsx",
      "parent": "/_dashboard/site/$id"
    },
    "/_dashboard/site/$id/logbook/": {
      "filePath": "_dashboard/site/$id/logbook/index.tsx",
      "parent": "/_dashboard/site/$id"
    },
    "/_dashboard/site/$id/medical-fluid/": {
      "filePath": "_dashboard/site/$id/medical-fluid/index.tsx",
      "parent": "/_dashboard/site/$id"
    },
    "/_dashboard/site/$id/monitoring/": {
      "filePath": "_dashboard/site/$id/monitoring/index.tsx",
      "parent": "/_dashboard/site/$id"
    },
    "/_dashboard/site/$id/my-actions/": {
      "filePath": "_dashboard/site/$id/my-actions/index.tsx",
      "parent": "/_dashboard/site/$id"
    },
    "/_dashboard/site/$id/non-conformity/": {
      "filePath": "_dashboard/site/$id/non-conformity/index.tsx",
      "parent": "/_dashboard/site/$id"
    },
    "/_dashboard/site/$id/reports/": {
      "filePath": "_dashboard/site/$id/reports/index.tsx",
      "parent": "/_dashboard/site/$id"
    },
    "/_dashboard/site/$id/sensor-plan/": {
      "filePath": "_dashboard/site/$id/sensor-plan/index.tsx",
      "parent": "/_dashboard/site/$id"
    },
    "/_dashboard/users/edit/$userId/": {
      "filePath": "_dashboard/users/edit/$userId/index.tsx",
      "parent": "/_dashboard"
    },
    "/_dashboard/site/$id/equipment/$equipmentId": {
      "filePath": "_dashboard/site/$id/equipment/$equipmentId",
      "parent": "/_dashboard/site/$id",
      "children": [
        "/_dashboard/site/$id/equipment/$equipmentId/_layout"
      ]
    },
    "/_dashboard/site/$id/equipment/$equipmentId/_layout": {
      "filePath": "_dashboard/site/$id/equipment/$equipmentId/_layout.tsx",
      "parent": "/_dashboard/site/$id/equipment/$equipmentId",
      "children": [
        "/_dashboard/site/$id/equipment/$equipmentId/_layout/actions",
        "/_dashboard/site/$id/equipment/$equipmentId/_layout/devices",
        "/_dashboard/site/$id/equipment/$equipmentId/_layout/information"
      ]
    },
    "/_dashboard/site/$id/actions-done/$actionId/": {
      "filePath": "_dashboard/site/$id/actions-done/$actionId/index.tsx",
      "parent": "/_dashboard/site/$id"
    },
    "/_dashboard/site/$id/alarms/$equipmentId/": {
      "filePath": "_dashboard/site/$id/alarms/$equipmentId/index.tsx",
      "parent": "/_dashboard/site/$id"
    },
    "/_dashboard/site/$id/alerts/create/": {
      "filePath": "_dashboard/site/$id/alerts/create/index.tsx",
      "parent": "/_dashboard/site/$id"
    },
    "/_dashboard/site/$id/boiler-room/technical/": {
      "filePath": "_dashboard/site/$id/boiler-room/technical/index.tsx",
      "parent": "/_dashboard/site/$id"
    },
    "/_dashboard/site/$id/comfort/monitoring/": {
      "filePath": "_dashboard/site/$id/comfort/monitoring/index.tsx",
      "parent": "/_dashboard/site/$id"
    },
    "/_dashboard/site/$id/dashboard/general/": {
      "filePath": "_dashboard/site/$id/dashboard/general/index.tsx",
      "parent": "/_dashboard/site/$id"
    },
    "/_dashboard/site/$id/dashboard/recommendations/": {
      "filePath": "_dashboard/site/$id/dashboard/recommendations/index.tsx",
      "parent": "/_dashboard/site/$id"
    },
    "/_dashboard/site/$id/defaults/$equipmentId/": {
      "filePath": "_dashboard/site/$id/defaults/$equipmentId/index.tsx",
      "parent": "/_dashboard/site/$id"
    },
    "/_dashboard/site/$id/drift/equipment/": {
      "filePath": "_dashboard/site/$id/drift/equipment/index.tsx",
      "parent": "/_dashboard/site/$id"
    },
    "/_dashboard/site/$id/drift/settings/": {
      "filePath": "_dashboard/site/$id/drift/settings/index.tsx",
      "parent": "/_dashboard/site/$id"
    },
    "/_dashboard/site/$id/electrical/$floorId/": {
      "filePath": "_dashboard/site/$id/electrical/$floorId/index.tsx",
      "parent": "/_dashboard/site/$id"
    },
    "/_dashboard/site/$id/equipment/choose-sample/": {
      "filePath": "_dashboard/site/$id/equipment/choose-sample/index.tsx",
      "parent": "/_dashboard/site/$id"
    },
    "/_dashboard/site/$id/equipment/create/": {
      "filePath": "_dashboard/site/$id/equipment/create/index.tsx",
      "parent": "/_dashboard/site/$id"
    },
    "/_dashboard/site/$id/equipment/energy/": {
      "filePath": "_dashboard/site/$id/equipment/energy/index.tsx",
      "parent": "/_dashboard/site/$id"
    },
    "/_dashboard/site/$id/heat-pump/mode/": {
      "filePath": "_dashboard/site/$id/heat-pump/mode/index.tsx",
      "parent": "/_dashboard/site/$id"
    },
    "/_dashboard/site/$id/heat-pump/technical/": {
      "filePath": "_dashboard/site/$id/heat-pump/technical/index.tsx",
      "parent": "/_dashboard/site/$id"
    },
    "/_dashboard/site/$id/information/add-work/": {
      "filePath": "_dashboard/site/$id/information/add-work/index.tsx",
      "parent": "/_dashboard/site/$id"
    },
    "/_dashboard/site/$id/lighting/$floorId/": {
      "filePath": "_dashboard/site/$id/lighting/$floorId/index.tsx",
      "parent": "/_dashboard/site/$id"
    },
    "/_dashboard/site/$id/logbook/$workId/": {
      "filePath": "_dashboard/site/$id/logbook/$workId/index.tsx",
      "parent": "/_dashboard/site/$id"
    },
    "/_dashboard/site/$id/logbook/add-log/": {
      "filePath": "_dashboard/site/$id/logbook/add-log/index.tsx",
      "parent": "/_dashboard/site/$id"
    },
    "/_dashboard/site/$id/medical-fluid/$floorId/": {
      "filePath": "_dashboard/site/$id/medical-fluid/$floorId/index.tsx",
      "parent": "/_dashboard/site/$id"
    },
    "/_dashboard/site/$id/monitoring/$deviceId/": {
      "filePath": "_dashboard/site/$id/monitoring/$deviceId/index.tsx",
      "parent": "/_dashboard/site/$id"
    },
    "/_dashboard/site/$id/my-actions/$actionId/": {
      "filePath": "_dashboard/site/$id/my-actions/$actionId/index.tsx",
      "parent": "/_dashboard/site/$id"
    },
    "/_dashboard/site/$id/non-conformity/$actionId/": {
      "filePath": "_dashboard/site/$id/non-conformity/$actionId/index.tsx",
      "parent": "/_dashboard/site/$id"
    },
    "/_dashboard/site/$id/operation/scheduler/": {
      "filePath": "_dashboard/site/$id/operation/scheduler/index.tsx",
      "parent": "/_dashboard/site/$id"
    },
    "/_dashboard/site/$id/sensor-plan/$floorId/": {
      "filePath": "_dashboard/site/$id/sensor-plan/$floorId/index.tsx",
      "parent": "/_dashboard/site/$id"
    },
    "/_dashboard/site/$id/vmc/technical/": {
      "filePath": "_dashboard/site/$id/vmc/technical/index.tsx",
      "parent": "/_dashboard/site/$id"
    },
    "/_dashboard/site/$id/equipment/$equipmentId/_layout/actions": {
      "filePath": "_dashboard/site/$id/equipment/$equipmentId/_layout/actions.tsx",
      "parent": "/_dashboard/site/$id/equipment/$equipmentId/_layout"
    },
    "/_dashboard/site/$id/equipment/$equipmentId/_layout/devices": {
      "filePath": "_dashboard/site/$id/equipment/$equipmentId/_layout/devices.tsx",
      "parent": "/_dashboard/site/$id/equipment/$equipmentId/_layout"
    },
    "/_dashboard/site/$id/equipment/$equipmentId/_layout/information": {
      "filePath": "_dashboard/site/$id/equipment/$equipmentId/_layout/information.tsx",
      "parent": "/_dashboard/site/$id/equipment/$equipmentId/_layout"
    },
    "/_dashboard/site/$id/alerts/edit/$alertId/": {
      "filePath": "_dashboard/site/$id/alerts/edit/$alertId/index.tsx",
      "parent": "/_dashboard/site/$id"
    },
    "/_dashboard/site/$id/alerts/edit/device-disconnected/": {
      "filePath": "_dashboard/site/$id/alerts/edit/device-disconnected/index.tsx",
      "parent": "/_dashboard/site/$id"
    },
    "/_dashboard/site/$id/boiler-room/technical/generate/": {
      "filePath": "_dashboard/site/$id/boiler-room/technical/generate/index.tsx",
      "parent": "/_dashboard/site/$id"
    },
    "/_dashboard/site/$id/boiler-room/technical/manage/": {
      "filePath": "_dashboard/site/$id/boiler-room/technical/manage/index.tsx",
      "parent": "/_dashboard/site/$id"
    },
    "/_dashboard/site/$id/comfort/monitoring/$floorId/": {
      "filePath": "_dashboard/site/$id/comfort/monitoring/$floorId/index.tsx",
      "parent": "/_dashboard/site/$id"
    },
    "/_dashboard/site/$id/comfort/monitoring/configuration/": {
      "filePath": "_dashboard/site/$id/comfort/monitoring/configuration/index.tsx",
      "parent": "/_dashboard/site/$id"
    },
    "/_dashboard/site/$id/devices/edit/$deviceId/": {
      "filePath": "_dashboard/site/$id/devices/edit/$deviceId/index.tsx",
      "parent": "/_dashboard/site/$id"
    },
    "/_dashboard/site/$id/equipment/energy/$equipmentId/": {
      "filePath": "_dashboard/site/$id/equipment/energy/$equipmentId/index.tsx",
      "parent": "/_dashboard/site/$id"
    },
    "/_dashboard/site/$id/heat-pump/technical/generate/": {
      "filePath": "_dashboard/site/$id/heat-pump/technical/generate/index.tsx",
      "parent": "/_dashboard/site/$id"
    },
    "/_dashboard/site/$id/heat-pump/technical/manage/": {
      "filePath": "_dashboard/site/$id/heat-pump/technical/manage/index.tsx",
      "parent": "/_dashboard/site/$id"
    },
    "/_dashboard/site/$id/information/work/$workId/": {
      "filePath": "_dashboard/site/$id/information/work/$workId/index.tsx",
      "parent": "/_dashboard/site/$id"
    },
    "/_dashboard/site/$id/operation/scheduler/$scheduleId/": {
      "filePath": "_dashboard/site/$id/operation/scheduler/$scheduleId/index.tsx",
      "parent": "/_dashboard/site/$id"
    },
    "/_dashboard/site/$id/operation/scheduler/create/": {
      "filePath": "_dashboard/site/$id/operation/scheduler/create/index.tsx",
      "parent": "/_dashboard/site/$id"
    },
    "/_dashboard/site/$id/reports/configuration/create/": {
      "filePath": "_dashboard/site/$id/reports/configuration/create/index.tsx",
      "parent": "/_dashboard/site/$id"
    },
    "/_dashboard/site/$id/vmc/technical/manage/": {
      "filePath": "_dashboard/site/$id/vmc/technical/manage/index.tsx",
      "parent": "/_dashboard/site/$id"
    },
    "/_dashboard/site/$id/alerts/edit/$alertId/comment/": {
      "filePath": "_dashboard/site/$id/alerts/edit/$alertId/comment/index.tsx",
      "parent": "/_dashboard/site/$id"
    },
    "/_dashboard/site/$id/boiler-room/technical/manage/$synopticId/": {
      "filePath": "_dashboard/site/$id/boiler-room/technical/manage/$synopticId/index.tsx",
      "parent": "/_dashboard/site/$id"
    },
    "/_dashboard/site/$id/heat-pump/technical/manage/$synopticId/": {
      "filePath": "_dashboard/site/$id/heat-pump/technical/manage/$synopticId/index.tsx",
      "parent": "/_dashboard/site/$id"
    },
    "/_dashboard/site/$id/operation/scheduler/cta/$zoneCtaId/": {
      "filePath": "_dashboard/site/$id/operation/scheduler/cta/$zoneCtaId/index.tsx",
      "parent": "/_dashboard/site/$id"
    },
    "/_dashboard/site/$id/reports/configuration/edit/$reportId/": {
      "filePath": "_dashboard/site/$id/reports/configuration/edit/$reportId/index.tsx",
      "parent": "/_dashboard/site/$id"
    }
  }
}
ROUTE_MANIFEST_END */
